import PropTypes from 'prop-types';
import EventBus from 'eventing-bus';
import { styled } from '@mui/system';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { Link } from 'react-router-dom';
import Tabs from '@material-ui/core/Tabs';
import Slider from '@mui/material/Slider';
import Switch from '@mui/material/Switch';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@mui/material/TextField';
import Accordion from '@mui/material/Accordion';
import React, { useState, useEffect, useRef } from 'react';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { Select, MenuItem, FormControl, Checkbox } from '@mui/material';
import { Modal, ModalBody, ModalHeader, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import '../index.css';
import axios from '../../../store/axios';
import constants from '../../../constants';
import ViewStateManager from '../../../utils/viewStateManager';

// ===========================
// Main AgentDetails Component
// ===========================

/** AgentDetails - Main component for agent details page **/
const Functions = ({ agentId, agentData, setAgentData, handleUpdateAgent, setSelectedFile }) => {

   // ========== Hooks and Redux ==========
   const dispatch = useDispatch()

   // ========== State Variables ==========
   const [valueLLMRange, setValueLLMRange] = useState(30);
   const [searchBackSound, setSearchBackSound] = useState('');
   const [selectBackSound, setSelectBackSound] = useState('');
   const [searchAPIEndpoint, setSearchAPIEndpoint] = useState('');
   const [selectAPIEndpoint, setSelectAPIEndpoint] = useState('');
   const [showVariablesBox, setShowVariablesBox] = useState(false);
   const [showHeadersValues, setShowHeadersValues] = useState(false);
   const [valueTabUsing, setValueCustomVoiceTab] = useState(0);
   const [valueJsonTemplate, setJsonTemplateValue] = useState(jsonTemplate);
   const [valueBackgroundSoundVolume, setBackgroundSoundVolume] = useState(30);
   const [headersValues, setHeadersValues] = useState([{ key: '', value: '' }]);
   const [showParametersValues, setShowParametersValues] = useState(false);
   const [parametersValues, setParametersValues] = useState([{ key: '', value: '' }]);


   // Load saved view state for this agent
   const savedAgentOptions = agentId ? ViewStateManager.getSingleAgentOptions(agentId) : { openOptions: [] };
   const [uiState, setUiState] = useState({
      expanded: savedAgentOptions.openOptions || [],
      isBackSound: false,
      modalEndCall: false,
      dropdownOpen: false,
      isAvailability: false,
      isBookMeeting: false,
      isCustomFunction: false,
      isAPIEndpoint: false,
      modalCallTransfer: false,
      modalPostCallAnalysis: false
   });

   // ========== Function State Variables ==========
   const [endCallForm, setEndCallForm] = useState({ name: 'end_call', description: 'Allows the agent to terminate the call when appropriate' });
   const [backgroundSoundSettings, setBackgroundSoundSettings] = useState({
      soundName: agentData?.backgroundSound?.soundName || 'none',
      volume: agentData?.backgroundSound?.volume || 30
   });
   const [checkAvailabilityForm, setCheckAvailabilityForm] = useState({
      name: 'check_calendar_availability',
      description: 'When users ask for availability, check the calendar and provide available slots',
      apiKey: '',
      eventId: '',
      timeZone: 'America/Los_Angeles'
   });

   const [createBookingForm, setCreateBookingForm] = useState({
      name: 'book_calendar',
      description: 'Books appointments on the calendar after confirming with the user',
      apiKey: '',
      eventId: '',
      timeZone: 'America/Los_Angeles'
   });

   // ========== Call Transfer State ==========
   const [callTransferForm, setCallTransferForm] = useState({
      name: 'transfer_call',
      description: 'Transfer the call to another number',
      transferTo: '',
      type: 'cold'
   });
   // ========== Custom Function State ==========
   const [customFunctionForm, setCustomFunctionForm] = useState({
      name: '',
      description: '',
      timeout: '',
      apiEndpoint: '',
      apiEndpointType: 'POST',
      method: 'POST',
      headers: [],
      queryParameters: [],
      parameters: [],
      // responseVariables: []
      // speakDuringExecution: false,
      // speakAfterExecution: false
   });

   // ========== Post Call Function State ==========
   const [postCallAnalysisForm, setPostCallAnalysisForm] = useState({ name: '', description: '' });
   const [editingPostCallAnalysis, setEditingPostCallAnalysis] = useState(null);


   const [customFunctionParameters, setCustomFunctionParameters] = useState([]);
   const [editingFunctionIndex, setEditingFunctionIndex] = useState(-1);
   const [isEditingFunction, setIsEditingFunction] = useState(false);

   // ========== Effect to Load Existing Data ==========
   useEffect(() => {
      if (agentData?.endCall) setEndCallForm(prev => ({ ...prev, ...agentData.endCall }));
      if (agentData?.checkAvailability) setCheckAvailabilityForm(prev => ({ ...prev, ...agentData.checkAvailability }));
      if (agentData?.createBooking) setCreateBookingForm(prev => ({ ...prev, ...agentData.createBooking }));
      if (agentData?.callTransfer) setCallTransferForm(prev => ({ ...prev, ...agentData.callTransfer }));
      if (agentData?.backgroundSound) setBackgroundSoundSettings(prev => ({ ...prev, ...agentData.backgroundSound }));
   }, [agentData]);

   // ========== Save expanded accordion state ==========
   useEffect(() => {
      if (agentId) {
         ViewStateManager.setSingleAgentOptions(agentId, { openOptions: uiState.expanded });
      }
   }, [agentId, uiState.expanded]);

   // ========== Event Handlers ==========
   const toggleEndCall = () => setUiState(prev => ({ ...prev, modalEndCall: !prev['modalEndCall'] }));
   const toggleCheckAvailability = () => setUiState(prev => ({ ...prev, isAvailability: !prev['isAvailability'] }));
   const toggleBookMeeting = () => setUiState(prev => ({ ...prev, isBookMeeting: !prev['isBookMeeting'] }));
   const toggleCustomFunction = () => setUiState(prev => ({ ...prev, isCustomFunction: !prev['isCustomFunction'] }));
   const togglePostCallAnalysis = () => setUiState(prev => ({ ...prev, modalPostCallAnalysis: !prev['modalPostCallAnalysis'] }));

   const toggleCallTransfer = () => {
      if (!uiState.modalCallTransfer) {
         // Opening modal - reset form with existing data or defaults
         if (agentData?.callTransfer) {
            setCallTransferForm({
               name: agentData.callTransfer.name || 'transfer_call',
               description: agentData.callTransfer.description || 'Transfer the call to another number',
               transferTo: agentData.callTransfer.transferTo || '',
               type: agentData.callTransfer.type || 'cold'
            });
         } else {
            // Reset to default values when creating new
            setCallTransferForm({
               name: 'transfer_call',
               description: 'Transfer the call to another number',
               transferTo: '',
               type: 'cold'
            });
         }
      }
      setUiState(prev => ({ ...prev, modalCallTransfer: !prev['modalCallTransfer'] }));
   };
   const handleTabsSetCustomVoice = (e, newValueCustomVoiceTab) => {
      // Auto-sync data when switching tabs
      if (newValueCustomVoiceTab === 0) {
         // Switching TO JSON tab - sync form data to JSON
         syncData('form-to-json');
      } else if (newValueCustomVoiceTab === 1) {
         // Switching TO Form tab - sync JSON data to form  
         syncData('json-to-form');
      }

      setValueCustomVoiceTab(newValueCustomVoiceTab);
   };

   const handleSilenceThresholdChange = (event, newValue) => setAgentData(prev => ({ ...prev, silenceThreshold: newValue }));
   const handleSilenceThreshold = (event, newValue) => {
      console.log('Silence threshold committed:', newValue);
      const updateData = { id: agentData['_id'], data: { silenceThreshold: newValue } }

      console.log('Dispatching update with data:', updateData);
      dispatch({ type: 'UPDATE_AGENT', payload: updateData });
   }

   const handleCallDuration = (event, newValue) => setAgentData(prev => ({ ...prev, maxCallDuration: newValue }));
   const handleCallDChange = (event, newValue) => {
      console.log('Max call duration committed:', newValue);

      // Create update data
      const updateData = { id: agentData._id, data: { maxCallDuration: newValue } }

      console.log('Dispatching update with data:', updateData);
      dispatch({ type: 'UPDATE_AGENT', payload: updateData });
   }

   const handleSilenceBlur = async () => {
      const silenceThreshold = agentData?.silenceThreshold || 10;
      if (silenceThreshold < 0) {
         setAgentData(prev => ({ ...prev, silenceThreshold: 0 }));
         handleSilenceThreshold(null, 0);
      } else if (silenceThreshold > 100) {
         setAgentData(prev => ({ ...prev, silenceThreshold: 100 }));
         handleSilenceThreshold(null, 100);
      }
   }

   const handleDurationBlur = async () => {
      const maxCallDuration = agentData?.maxCallDuration || 300;
      if (maxCallDuration < 0) {
         setAgentData(prev => ({ ...prev, maxCallDuration: 0 }));
         handleCallDChange(null, 0);
      } else if (maxCallDuration > 600) {
         setAgentData(prev => ({ ...prev, maxCallDuration: 600 }));
         handleCallDChange(null, 600);
      }
   }

   const handleSilenceInputChange = (event) => {
      const value = event.target.value === '' ? 0 : Number(event.target.value);
      setAgentData(prev => ({ ...prev, silenceThreshold: value }));
      handleSilenceThreshold(null, value);
   }

   const handleCallDurationInput = (event) => {
      const value = event.target.value === '' ? 0 : Number(event.target.value);
      setAgentData(prev => ({ ...prev, maxCallDuration: value }));
      handleCallDChange(null, value);
   }

   const handlePauseChangeCommited = (event, newValue) => {
      try {
         const roundedValue = Math.min(Math.max(Number(newValue.toFixed(1)), 0.1), 5);
         setAgentData(prev => ({ ...prev, pauseBeforeSpeaking: roundedValue }));

         // Create update data
         const updateData = { id: agentData['_id'], data: { pauseBeforeSpeaking: roundedValue } }

         console.log('Dispatching update with data:', updateData);
         dispatch({ type: 'UPDATE_AGENT', payload: updateData });
      } catch (error) { console.error('Error updating pause before speaking:', error) }
   }

   const handlePauseBlur = () => {
      try {
         const pauseBeforeSpeaking = agentData?.pauseBeforeSpeaking || 1;
         const value = Number(pauseBeforeSpeaking);
         if (isNaN(value)) handlePauseChangeCommited(null, 1);
         else if (value < 0) handlePauseChangeCommited(null, 0);
         else if (value > 5) handlePauseChangeCommited(null, 5);
         else {
            const roundedValue = Number(value.toFixed(1));
            handlePauseChangeCommited(null, roundedValue);
         }
      } catch (error) { console.error('Error in blur handler:', error) }
   }

   const handlePauseInputChange = (event) => {
      const value = event.target.value === '' ? 1 : Number(event.target.value);
      if (!isNaN(value)) setAgentData(prev => ({ ...prev, pauseBeforeSpeaking: value }));
   }

   const handlePostCallAnalysisFormChange = (field, value) => {
      setPostCallAnalysisForm(prev => ({ ...prev, [field]: value }));
   };

   const handleFileChange = (e) => {
      const file = e['target']['files'][0];
      if (file) {
         setSelectedFile(file);
         handleUpdateAgent(file);
      }
   }

   const handleDeleteFile = async (fileId, fileName) => {
      try {
         const response = await axios.delete(`/agent/${agentId}/knowledge-base/${fileId}`);

         if (response.data && response.data.body) {
            setAgentData(response.data.body);
            EventBus.publish('success', 'Knowledge base file deleted successfully');
         }
      } catch (error) {
         console.error('Error deleting file:', error);
         EventBus.publish('error', error?.response?.data?.message || 'Failed to delete file');
      }
   }

   const handleSliderChange = (event, newValue) => setValueLLMRange(newValue);
   const changeTab = (panel) => (event, isExpanded) => {
      setUiState((prev) => ({
         ...prev,
         expanded: isExpanded
            ? [...prev.expanded, panel] // panel add karo
            : prev.expanded.filter((p) => p !== panel), // panel hatao agar close ho
      }));
   };
   const handleBlur = () => { if (valueLLMRange < 0) setValueLLMRange(0); else if (valueLLMRange > 100) setValueLLMRange(100) }
   const handleInputChange = (event) => setValueLLMRange(event['target']['valueLLMRange'] === '' ? 0 : Number(event['target']['valueLLMRange']));

   //    const handleBackgroundSoundSelect = (soundName) => {setBackgroundSoundSettings(prev => ({...prev,soundName}));
   //   // Update agent data immediately or you can batch these updates
   //   const updateData = { id: agentData._id, data: { backgroundSound: {soundName,volume: backgroundSoundSettings.volume}}};
   const handleBackgroundSoundSelect = (soundName) => {
      const newSettings = {
         soundName,
         volume: backgroundSoundSettings.volume
      };
      setBackgroundSoundSettings(newSettings);

      const updateData = {
         id: agentData._id,
         data: {
            backgroundSound: newSettings
         }
      };
      dispatch({ type: 'UPDATE_AGENT', payload: updateData });
   };
   const handleBackgroundVolumeChange = (event, newValue) => {
      setBackgroundSoundSettings(prev => ({
         ...prev,
         volume: newValue
      }));

   };

   // Define API endpoint options since they don't exist in constants
   const apiEndpointOptions = [
      { label: 'GET', value: 'GET' },
      { label: 'POST', value: 'POST' },
      { label: 'PUT', value: 'PUT' },
      { label: 'DELETE', value: 'DELETE' },
      { label: 'PATCH', value: 'PATCH' }
   ];

   const filteredoptionsApiEndpoint = apiEndpointOptions.filter((option) => option['label'].toLowerCase().includes(searchAPIEndpoint.toLowerCase()));

   const handleEditChange = (e) => {
      setAgentData(prev => ({ ...prev, [e['target']['name']]: e['target']['value'] }));
   }

   const handleRecordingToggle = (event) => {
      setAgentData(prev => {
         const updated = { ...prev, enableRecording: event.target.checked };
         console.log('Updated agentData:', updated);
         return updated;
      });
      const updateData = { id: agentData._id, data: { enableRecording: event.target.checked } };

      dispatch({ type: 'UPDATE_AGENT', payload: updateData });
   }

   const handleTranscriptToggle = (event) => {
      setAgentData(prev => {
         const updated = { ...prev, enableTranscript: event.target.checked };
         return updated;
      });
      const updateData = { id: agentData._id, data: { enableTranscript: event.target.checked } };
      dispatch({ type: 'UPDATE_AGENT', payload: updateData });
   }

   const handleVoiceMailDetectionToggle = (event) => {
      setAgentData(prev => {
         const updated = { ...prev, voiceMailDetection: event.target.checked };
         return updated;
      });
      const updateData = { id: agentData._id, data: { voiceMailDetection: event.target.checked } };
      dispatch({ type: 'UPDATE_AGENT', payload: updateData });
   }

   // ========== Function Save data in agent  ==========
   const handleSaveEndCall = () => {
      const updateData = { id: agentData._id, data: { endCall: endCallForm } };
      dispatch({ type: 'UPDATE_AGENT', payload: updateData });
      setAgentData(prev => ({ ...prev, endCall: endCallForm }));
      toggleEndCall();
   };

   const handleSaveCallTransfer = () => {
      // Validation - check required fields
      if (!callTransferForm.name.trim()) {
         EventBus.publish('error', 'Please enter a name for the call transfer function');
         return;
      }

      if (!callTransferForm.transferTo.trim()) {
         EventBus.publish('error', 'Please enter a phone number to transfer to');
         return;
      }

      if (!callTransferForm.type) {
         EventBus.publish('error', 'Please select a transfer type');
         return;
      }

      // Validate phone number format (basic validation)
      const phoneRegex = /^\+?[\d\s\-\(\)]+$/;
      if (!phoneRegex.test(callTransferForm.transferTo)) {
         EventBus.publish('error', 'Please enter a valid phone number');
         return;
      }

      // Save only after validation passes
      const updateData = {
         id: agentData._id,
         data: { callTransfer: callTransferForm }
      };

      dispatch({ type: 'UPDATE_AGENT', payload: updateData });
      setAgentData(prev => ({ ...prev, callTransfer: callTransferForm }));
      toggleCallTransfer();

      // Show success message
      EventBus.publish('success', 'Call transfer function saved successfully');
   };

   const handleSaveCheckAvailability = () => {
      const updateData = { id: agentData._id, data: { checkAvailability: checkAvailabilityForm } };

      // Dispatch the update action
      dispatch({ type: 'UPDATE_AGENT', payload: updateData });
      setAgentData(prev => ({ ...prev, checkAvailability: checkAvailabilityForm }));

      // Close the modal immediately
      toggleCheckAvailability();
   };

   const handleSaveCreateBooking = () => {
      const updateData = { id: agentData._id, data: { createBooking: createBookingForm } };

      // Dispatch the update action
      dispatch({ type: 'UPDATE_AGENT', payload: updateData });
      setAgentData(prev => ({ ...prev, createBooking: createBookingForm }));

      // Close the modal immediately
      toggleBookMeeting();
   };

   const handleSavePostCallAnalysis = () => {
      const updatedList = [...(agentData.postCallAnalysis || [])];

      if (editingPostCallAnalysis !== null) updatedList[editingPostCallAnalysis] = postCallAnalysisForm;
      else updatedList.push(postCallAnalysisForm);

      const updateData = { id: agentData._id, data: { postCallAnalysis: updatedList, } };
      dispatch({ type: 'UPDATE_AGENT', payload: updateData });
      setAgentData(prev => ({ ...prev, postCallAnalysis: updatedList }));
      setPostCallAnalysisForm({ name: '', description: '' });
      setEditingPostCallAnalysis(null);
      togglePostCallAnalysis();
   };


   const handleEndCallFormChange = (field, value) => setEndCallForm(prev => ({ ...prev, [field]: value }));
   const handleCallTransferFormChange = (field, value) => setCallTransferForm(prev => ({ ...prev, [field]: value }));
   const handleCheckAvailabilityFormChange = (field, value) => setCheckAvailabilityForm(prev => ({ ...prev, [field]: value }));
   const handleCreateBookingFormChange = (field, value) => setCreateBookingForm(prev => ({ ...prev, [field]: value }));


   const volumePopupRef = useRef(null);
   const volumeButtonRef = useRef(null);

   const toggleContentVeriablesBox = () => setShowVariablesBox(!showVariablesBox);
   
   // Close volume popup when clicking outside
   useEffect(() => {
      if (!showVariablesBox) return;

      const handleClickOutside = (event) => {
         const popup = volumePopupRef.current;
         const button = volumeButtonRef.current;
         
         if (!popup || !button) return;
         
         const clickedOutsidePopup = !popup.contains(event.target);
         const clickedOutsideButton = !button.contains(event.target);
         
         if (clickedOutsidePopup && clickedOutsideButton) {
            setShowVariablesBox(false);
         }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
   }, [showVariablesBox]);
   
   // const toggleHeaderValues = () => setShowHeadersValues(!showHeadersValues);
   // const toggleParametersValues = () => setShowParametersValues(!showParametersValues);

   // const handcontactdHeader = () => {
   //    setHeadersValues(prev => [...prev, { key: '', value: '' }]);
   // };

   // const handleRemoveHeader = (index) => {
   //    const updated = headersValues.filter((_, i) => i !== index);
   //    setHeadersValues(updated);
   // };

   // const handleHeaderChange = (index, field, value) => {
   //    const updated = [...headersValues];
   //    updated[index][field] = value;
   //    setHeadersValues(updated);
   // };

   const formatJSON = () => {
      try {
         const parsed = JSON.parse(valueJsonTemplate);
         setJsonTemplateValue(JSON.stringify(parsed, null, 2));
      } catch (err) {
         console.error('JSON parsing error:', err);
         EventBus.publish('error', 'Invalid JSON format. Please check your syntax.');
      }
   };

   // Example JSON templates
   const loadExample = (exampleNumber) => {
      let exampleJson = '';

      switch (exampleNumber) {
         case 1:
            exampleJson = {
               "type": "object",
               "properties": {},
               "required": [],
               "additionalProperties": false
            }
            break;
         case 2:
            exampleJson = {
               "type": "object",
               "properties": {
                  "appointment_date": {
                     "type": "string",
                     "description": "The date for the appointment in YYYY-MM-DD format"
                  },
                  "appointment_time": {
                     "type": "string",
                     "description": "The time for the appointment in HH:MM format"
                  },
                  "duration": {
                     "type": "number",
                     "description": "Duration of the appointment in minutes"
                  }
               },
               "required": ["appointment_date", "appointment_time"],
               "additionalProperties": false
            };
            break;
         case 3:
            exampleJson = {
               "type": "object",
               "properties": {
                  "product_id": {
                     "type": "string",
                     "description": "The unique identifier for the product"
                  },
                  "quantity": {
                     "type": "number",
                     "description": "The quantity of the product"
                  },
                  "urgent": {
                     "type": "boolean",
                     "description": "Whether this is an urgent request"
                  }
               },
               "required": ["product_id", "quantity"],
               "additionalProperties": false
            };
            break;
         default:
            return;
      }

      setJsonTemplateValue(JSON.stringify(exampleJson, null, 2));
   };

   // ========== Custom Function Handlers ==========
   const handleCustomFunctionFormChange = (field, value) => setCustomFunctionForm(prev => ({ ...prev, [field]: value }));

   const handleEditCustomFunction = (index) => {
      if (agentData?.customFunctions && agentData.customFunctions[index]) {
         const functionToEdit = agentData.customFunctions[index];
         setCustomFunctionForm({
            name: functionToEdit.name || '',
            description: functionToEdit.description || '',
            timeout: functionToEdit.timeout || '',
            apiEndpoint: functionToEdit.apiEndpoint || '',
            apiEndpointType: functionToEdit.apiEndpointType || functionToEdit.method || 'GET',
            method: functionToEdit.method || 'GET',
            headers: functionToEdit.headers || [],
            queryParameters: functionToEdit.queryParameters || [],
            parameters: functionToEdit.parameters || [],
            // responseVariables: functionToEdit.responseVariables || [],
            // speakDuringExecution: functionToEdit.speakDuringExecution || false,
            // speakAfterExecution: functionToEdit.speakAfterExecution !== undefined ? functionToEdit.speakAfterExecution : true
         });

         // Convert function parameters to form parameters
         if (functionToEdit.parameters && functionToEdit.parameters.properties) {
            const params = Object.keys(functionToEdit.parameters.properties).map(key => ({
               name: key,
               description: functionToEdit.parameters.properties[key].description || '',
               type: functionToEdit.parameters.properties[key].type || 'string',
               required: functionToEdit.parameters.required ? functionToEdit.parameters.required.includes(key) : false
            }));
            setCustomFunctionParameters(params);
            setJsonTemplateValue(JSON.stringify(functionToEdit.parameters, null, 2));
         } else {
            setCustomFunctionParameters([]);
            setJsonTemplateValue(jsonTemplate);
         }

         setEditingFunctionIndex(index);
         setIsEditingFunction(true);
         toggleCustomFunction();
      }
   };

   const handcontactdNewCustomFunction = () => {
      // Reset form for new function
      setCustomFunctionForm({
         name: '',
         description: '',
         timeout: '',
         apiEndpoint: '',
         apiEndpointType: 'POST',
         method: 'POST',
         headers: [],
         queryParameters: [],
         parameters: [],
         // responseVariables: []
         // speakDuringExecution: false,
         // speakAfterExecution: false
      });
      setCustomFunctionParameters([]);
      setJsonTemplateValue(jsonTemplate);
      setEditingFunctionIndex(-1);
      setIsEditingFunction(false);
      toggleCustomFunction();
   };

   const handleDeleteCustomFunction = async (index) => {
      if (window.confirm('Are you sure you want to delete this custom function?')) {
         try {
            // Remove the function from the array
            const updatedFunctions = [...(agentData.customFunctions || [])];
            updatedFunctions.splice(index, 1);

            const updateData = { id: agentData._id, data: { customFunctions: updatedFunctions } };

            await new Promise((resolve, reject) => {
               dispatch({
                  type: 'UPDATE_AGENT',
                  payload: { ...updateData, onSuccess: resolve, onError: reject }
               });
            });

            setAgentData(prev => ({ ...prev, customFunctions: updatedFunctions }));
            EventBus.publish('success', 'Custom function deleted successfully');
         } catch (error) {
            console.error('Failed to delete custom function:', error);
            EventBus.publish('error', 'Failed to delete custom function');
         }
      }
   };

   const handleSaveCustomFunction = async () => {
      try {
         // Build the schema object
         const schema = {
            type: "function",
            name: customFunctionForm.name,
            description: customFunctionForm.description,
            timeout: customFunctionForm.timeout,
            apiEndpoint: customFunctionForm.apiEndpoint,
            apiEndpointType: customFunctionForm.apiEndpointType,
            method: customFunctionForm.method,
            headers: customFunctionForm.headers,
            queryParameters: customFunctionForm.queryParameters,
            // responseVariables: customFunctionForm.responseVariables,
            // speakDuringExecution: customFunctionForm.speakDuringExecution,
            // speakAfterExecution: customFunctionForm.speakAfterExecution,
            parameters: {
               type: "object",
               properties: {},
               required: [],
               additionalProperties: false
            }
         };

         // Check if we're using JSON tab (index 0) or Form tab (index 1)
         if (valueTabUsing === 0) {
            // Parse JSON from the JSON editor
            try {
               const jsonSchema = JSON.parse(valueJsonTemplate);
               if (jsonSchema && jsonSchema.properties) {
                  schema.parameters = {
                     type: "object",
                     properties: jsonSchema.properties,
                     required: jsonSchema.required || [],
                     additionalProperties: jsonSchema.additionalProperties !== undefined ? jsonSchema.additionalProperties : false
                  };
               }
            } catch (jsonError) {
               console.error('Invalid JSON in parameters:', jsonError);
               EventBus.publish('error', 'Invalid JSON format in parameters. Please check your JSON syntax.');
               return;
            }
         } else {
            // Convert form parameters to schema format (existing logic)
            customFunctionParameters.forEach(param => {
               if (param.name) {
                  schema.parameters.properties[param.name] = {
                     type: param.type,
                     description: param.description
                  };
                  if (param.required) schema.parameters.required.push(param.name);
               }
            });
         }

         // Determine if we're creating new or updating existing
         const isUpdating = editingFunctionIndex >= 0;
         const updatedFunctions = [...(agentData.customFunctions || [])];

         if (isUpdating) updatedFunctions[editingFunctionIndex] = schema;
         else updatedFunctions.push(schema);

         const updateData = { id: agentData._id, data: { customFunctions: updatedFunctions } };

         await new Promise((resolve, reject) => {
            dispatch({
               type: 'UPDATE_AGENT',
               payload: { ...updateData, onSuccess: resolve, onError: reject }
            });
         });

         setAgentData(prev => ({ ...prev, customFunctions: updatedFunctions }));
         toggleCustomFunction();
         EventBus.publish('success', isUpdating ? 'Custom function updated successfully' : 'Custom function added successfully');

      } catch (error) {
         console.error('Failed to save custom function:', error);
      }
   };

   // Unified sync function - handles both JSON and Form syncing
   const syncData = (direction = 'auto') => {
      // Auto-detect direction based on current tab like when user switch to json tab then it will sync form to json
      const actualDirection = direction === 'auto'
         ? (valueTabUsing === 0 ? 'json-to-form' : 'form-to-json')
         : direction;

      if (actualDirection === 'form-to-json') {
         const jsonSchema = {
            type: "object",
            properties: {},
            required: [],
            additionalProperties: false
         };

         customFunctionParameters.forEach(param => {
            if (param.name) {
               jsonSchema.properties[param.name] = {
                  type: param.type,
                  description: param.description
               };
               if (param.required) jsonSchema.required.push(param.name);
            }
         });

         setJsonTemplateValue(JSON.stringify(jsonSchema, null, 2));

      } else if (actualDirection === 'json-to-form') {
         try {
            const jsonSchema = JSON.parse(valueJsonTemplate);
            if (jsonSchema && jsonSchema.properties) {
               const params = Object.keys(jsonSchema.properties).map(key => ({
                  name: key,
                  description: jsonSchema.properties[key].description || '',
                  type: jsonSchema.properties[key].type || 'string',
                  required: jsonSchema.required ? jsonSchema.required.includes(key) : false
               }));
               setCustomFunctionParameters(params);
            }
         } catch (error) {
            console.error('Invalid JSON format:', error);
            EventBus.publish('error', 'Invalid JSON format. Please check your JSON syntax.');
         }
      }
   };

   // Parameter management handlers
   const handleParameterChange = (index, field, value) => {
      const updatedParams = [...customFunctionParameters];
      updatedParams[index][field] = value;
      setCustomFunctionParameters(updatedParams);
   };

   const handcontactdParameter = () => {
      setCustomFunctionParameters(prev => [...prev, { name: '', description: '', type: 'string', required: false }]);
   };

   const handleRemoveParameter = (index) => {
      setCustomFunctionParameters(prev => prev.filter((_, i) => i !== index));
   };

   return (
      <>
         {/* ========== Functionality Accordions ========== */}
         <div className='function-box'>
            <div className='accordioan-box'>

               {/* --------------- Trigger--------------- */}
               {/* <Accordion expanded={uiState.expanded.includes('panel11')} onChange={changeTab('panel11')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel1bh-content' id='panel1bh-header'>
                     <Typography component='span' sx={{ width: '33%', flexShrink: 0 }}>
                        <i className='icon'><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.8275 13.2709C5.71084 13.2709 5.6175 13.2475 5.5475 13.2184C5.31417 13.1309 4.9175 12.845 4.9175 11.9409V8.17837H3.5525C2.77084 8.17837 2.49084 7.81087 2.39167 7.59503C2.2925 7.37337 2.205 6.9242 2.71834 6.33503L7.13417 1.31837C7.72917 0.641701 8.21334 0.688368 8.44667 0.775868C8.68 0.863368 9.07667 1.1492 9.07667 2.05337V5.81587H10.4417C11.2233 5.81587 11.5033 6.18337 11.6025 6.3992C11.7017 6.62087 11.7892 7.07003 11.2758 7.6592L6.86 12.6759C6.44584 13.1484 6.08417 13.2709 5.8275 13.2709ZM8.12584 1.59837C8.10834 1.6217 7.98584 1.68003 7.79334 1.9017L3.3775 6.91837C3.21417 7.10503 3.19084 7.2217 3.19084 7.24503C3.2025 7.25087 3.3075 7.3092 3.5525 7.3092H5.355C5.59417 7.3092 5.7925 7.50753 5.7925 7.7467V11.9467C5.7925 12.2384 5.845 12.3667 5.86834 12.4017C5.88584 12.3784 6.00834 12.32 6.20084 12.0984L10.6167 7.0817C10.78 6.89503 10.8033 6.77837 10.8033 6.75503C10.7917 6.7492 10.6867 6.69087 10.4417 6.69087H8.63917C8.4 6.69087 8.20167 6.49253 8.20167 6.25337V2.05337C8.2075 1.7617 8.14917 1.6392 8.12584 1.59837Z" fill="#541530"/></svg></i>
                        Trigger
                     </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                     <div className='detail-accordian-box'>
                        <p>Add triggers to automatically start your agent based on events like emails, schedules, or webhooks.</p>


                        <button className='btn-style-border'>+ Add</button>
                     </div>
                  </AccordionDetails>
               </Accordion> */}

               {/* --------------- Functions--------------- */}
               <Accordion expanded={uiState.expanded.includes('panel1')} onChange={changeTab('panel1')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel1bh-content' id='panel1bh-header'>
                     <Typography component='span' sx={{ width: '33%', flexShrink: 0 }}>
                        <i className='icon'><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5325 6.56234H9.17583C8.00333 6.56234 7.4375 6.04317 7.4375 4.96984V2.3215C7.4375 1.24817 8.00917 0.729004 9.17583 0.729004H11.5325C12.705 0.729004 13.2708 1.24817 13.2708 2.3215V4.964C13.2708 6.04317 12.6992 6.56234 11.5325 6.56234ZM9.17583 1.604C8.39417 1.604 8.3125 1.82567 8.3125 2.3215V4.964C8.3125 5.46567 8.39417 5.6815 9.17583 5.6815H11.5325C12.3142 5.6815 12.3958 5.45984 12.3958 4.964V2.3215C12.3958 1.81984 12.3142 1.604 11.5325 1.604H9.17583Z" fill="var(--primary-color)" /><path d="M11.5325 13.2708H9.17583C8.00333 13.2708 7.4375 12.6992 7.4375 11.5325V9.17583C7.4375 8.00333 8.00917 7.4375 9.17583 7.4375H11.5325C12.705 7.4375 13.2708 8.00917 13.2708 9.17583V11.5325C13.2708 12.6992 12.6992 13.2708 11.5325 13.2708ZM9.17583 8.3125C8.4875 8.3125 8.3125 8.4875 8.3125 9.17583V11.5325C8.3125 12.2208 8.4875 12.3958 9.17583 12.3958H11.5325C12.2208 12.3958 12.3958 12.2208 12.3958 11.5325V9.17583C12.3958 8.4875 12.2208 8.3125 11.5325 8.3125H9.17583Z" fill="var(--primary-color)" /><path d="M4.82425 6.56234H2.46758C1.29508 6.56234 0.729248 6.04317 0.729248 4.96984V2.3215C0.729248 1.24817 1.30091 0.729004 2.46758 0.729004H4.82425C5.99675 0.729004 6.56258 1.24817 6.56258 2.3215V4.964C6.56258 6.04317 5.99091 6.56234 4.82425 6.56234ZM2.46758 1.604C1.68591 1.604 1.60425 1.82567 1.60425 2.3215V4.964C1.60425 5.46567 1.68591 5.6815 2.46758 5.6815H4.82425C5.60592 5.6815 5.68758 5.45984 5.68758 4.964V2.3215C5.68758 1.81984 5.60592 1.604 4.82425 1.604H2.46758Z" fill="var(--primary-color)" /><path d="M4.82425 13.2708H2.46758C1.29508 13.2708 0.729248 12.6992 0.729248 11.5325V9.17583C0.729248 8.00333 1.30091 7.4375 2.46758 7.4375H4.82425C5.99675 7.4375 6.56258 8.00917 6.56258 9.17583V11.5325C6.56258 12.6992 5.99091 13.2708 4.82425 13.2708ZM2.46758 8.3125C1.77925 8.3125 1.60425 8.4875 1.60425 9.17583V11.5325C1.60425 12.2208 1.77925 12.3958 2.46758 12.3958H4.82425C5.51258 12.3958 5.68758 12.2208 5.68758 11.5325V9.17583C5.68758 8.4875 5.51258 8.3125 4.82425 8.3125H2.46758Z" fill="var(--primary-color)" /></svg></i>
                        Functions
                     </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                     <div className='detail-accordian-box'>
                        <p>Enable your agent with capabilities such as calendar bookings, call termination, etc.</p>

                        {/* Display  functions which user added*/}
                        <div style={{ marginBottom: '10px' }}>
                           {agentData?.endCall && (
                              <div className='group-from'>
                                 <span className='end-call-icon'>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.1792 13.2709C9.52008 13.2709 8.82591 13.1134 8.10841 12.8101C7.40841 12.5126 6.70258 12.1042 6.01425 11.6084C5.33175 11.1067 4.67258 10.5467 4.04841 9.93425C3.43008 9.31008 2.87008 8.65092 2.37425 7.97425C1.87258 7.27425 1.47008 6.57425 1.18425 5.89758C0.880915 5.17425 0.729248 4.47425 0.729248 3.81508C0.729248 3.36008 0.810915 2.92841 0.968415 2.52591C1.13175 2.11175 1.39425 1.72675 1.75008 1.39425C2.19925 0.950915 2.71258 0.729248 3.26091 0.729248C3.48841 0.729248 3.72175 0.781748 3.92008 0.875081C4.14758 0.980081 4.34008 1.13758 4.48008 1.34758L5.83341 3.25508C5.95591 3.42425 6.04925 3.58758 6.11341 3.75091C6.18925 3.92591 6.23008 4.10091 6.23008 4.27008C6.23008 4.49175 6.16591 4.70758 6.04341 4.91175C5.95591 5.06925 5.82175 5.23842 5.65258 5.40758L5.25591 5.82175C5.26175 5.83925 5.26758 5.85091 5.27341 5.86258C5.34341 5.98508 5.48341 6.19508 5.75175 6.51008C6.03758 6.83675 6.30591 7.13425 6.57425 7.40841C6.91841 7.74675 7.20425 8.01508 7.47258 8.23675C7.80508 8.51675 8.02091 8.65675 8.14925 8.72092L8.13758 8.75008L8.56341 8.33008C8.74425 8.14925 8.91925 8.01508 9.08841 7.92758C9.40925 7.72925 9.81758 7.69425 10.2259 7.86341C10.3776 7.92758 10.5409 8.01508 10.7159 8.13758L12.6526 9.51425C12.8684 9.66008 13.0259 9.84675 13.1192 10.0684C13.2067 10.2901 13.2476 10.4942 13.2476 10.6984C13.2476 10.9784 13.1834 11.2584 13.0609 11.5209C12.9384 11.7834 12.7867 12.0109 12.5942 12.2209C12.2617 12.5884 11.9001 12.8509 11.4801 13.0201C11.0776 13.1834 10.6401 13.2709 10.1792 13.2709ZM3.26091 1.60425C2.94008 1.60425 2.64258 1.74425 2.35675 2.02425C2.08841 2.27508 1.90175 2.54925 1.78508 2.84675C1.66258 3.15008 1.60425 3.47091 1.60425 3.81508C1.60425 4.35758 1.73258 4.94675 1.98925 5.55342C2.25175 6.17175 2.61925 6.81342 3.08591 7.45508C3.55258 8.09675 4.08341 8.72092 4.66675 9.31008C5.25008 9.88758 5.88008 10.4242 6.52758 10.8967C7.15758 11.3576 7.80508 11.7309 8.44675 11.9992C9.44425 12.4251 10.3776 12.5242 11.1476 12.2034C11.4451 12.0809 11.7076 11.8942 11.9467 11.6259C12.0809 11.4801 12.1859 11.3226 12.2734 11.1359C12.3434 10.9901 12.3784 10.8384 12.3784 10.6867C12.3784 10.5934 12.3609 10.5001 12.3142 10.3951C12.2967 10.3601 12.2617 10.2959 12.1509 10.2201L10.2142 8.84342C10.0976 8.76175 9.99258 8.70342 9.89341 8.66258C9.76508 8.61008 9.71258 8.55758 9.51425 8.68008C9.39758 8.73842 9.29258 8.82592 9.17591 8.94258L8.73258 9.38008C8.50508 9.60175 8.15508 9.65425 7.88675 9.55508L7.72925 9.48508C7.49008 9.35675 7.21008 9.15841 6.90091 8.89592C6.62091 8.65675 6.31758 8.37675 5.95008 8.01508C5.66425 7.72341 5.37841 7.41425 5.08091 7.07008C4.80675 6.74925 4.60841 6.47508 4.48591 6.24758L4.41591 6.07258C4.38091 5.93842 4.36925 5.86258 4.36925 5.78091C4.36925 5.57091 4.44508 5.38425 4.59091 5.23841L5.02841 4.78341C5.14508 4.66675 5.23258 4.55591 5.29091 4.45675C5.33758 4.38091 5.35508 4.31675 5.35508 4.25841C5.35508 4.21175 5.33758 4.14175 5.30841 4.07175C5.26758 3.97842 5.20341 3.87341 5.12175 3.76258L3.76841 1.84925C3.71008 1.76758 3.64008 1.70925 3.55258 1.66841C3.45925 1.62758 3.36008 1.60425 3.26091 1.60425ZM8.13758 8.75592L8.04425 9.15258L8.20175 8.74425C8.17258 8.73841 8.14925 8.74425 8.13758 8.75592Z" fill="#4B5563"></path></svg>
                                 </span>
                                 <TextField
                                    fullWidth
                                    hiddenLabel
                                    size='small'
                                    variant='standard'
                                    value={agentData.endCall.name}
                                    disabled
                                 />
                                 <div className='edit-remove-btn'>
                                    <button className='edit-btn' onClick={toggleEndCall}>
                                       <span className=''>
                                          <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path d="M4.42391 13.8267C3.99183 13.8267 3.58808 13.6779 3.29766 13.4017C2.92933 13.0546 2.75225 12.5304 2.816 11.9638L3.07808 9.66876C3.12766 9.23668 3.38975 8.66293 3.69433 8.35126L9.50975 2.19585C10.9618 0.658764 12.4777 0.616265 14.0147 2.06835C15.5518 3.52043 15.5943 5.03626 14.1422 6.57335L8.32683 12.7288C8.02933 13.0475 7.47683 13.345 7.04475 13.4158L4.76391 13.8054C4.6435 13.8125 4.53725 13.8267 4.42391 13.8267ZM11.7835 2.06126C11.2381 2.06126 10.7635 2.40126 10.2818 2.91126L4.46641 9.07376C4.32475 9.22252 4.16183 9.57668 4.1335 9.7821L3.87141 12.0771C3.84308 12.3108 3.89975 12.5021 4.02725 12.6225C4.15475 12.7429 4.346 12.7854 4.57975 12.75L6.86058 12.3604C7.066 12.325 7.406 12.1408 7.54766 11.9921L13.3631 5.83668C14.2414 4.90168 14.5602 4.03751 13.2781 2.83335C12.7114 2.28793 12.2227 2.06126 11.7835 2.06126Z" fill="#4B5563" />
                                             <path d="M12.7825 7.75643C12.7684 7.75643 12.7471 7.75643 12.7329 7.75643C10.5229 7.53684 8.74502 5.8581 8.40502 3.66226C8.36252 3.37185 8.56086 3.10268 8.85127 3.05309C9.14169 3.01059 9.41086 3.20893 9.46044 3.49935C9.72961 5.21351 11.1179 6.53101 12.8463 6.70101C13.1367 6.72935 13.3492 6.99143 13.3209 7.28184C13.2854 7.55101 13.0517 7.75643 12.7825 7.75643Z" fill="#4B5563" />
                                             <path d="M15.375 16.1147H2.625C2.33458 16.1147 2.09375 15.8739 2.09375 15.5835C2.09375 15.2931 2.33458 15.0522 2.625 15.0522H15.375C15.6654 15.0522 15.9062 15.2931 15.9062 15.5835C15.9062 15.8739 15.6654 16.1147 15.375 16.1147Z" fill="#4B5563" />
                                          </svg>
                                       </span>
                                    </button>
                                    <button className='edit-btn' onClick={() => {
                                       const updateData = { id: agentData._id, data: { endCall: null } };
                                       dispatch({ type: 'UPDATE_AGENT', payload: updateData });
                                       setAgentData(prev => ({ ...prev, endCall: null }));
                                    }}>
                                      <span className=''>
                                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.25 3.92578C12.2383 3.92578 12.2208 3.92578 12.2033 3.92578C9.11751 3.61661 6.03751 3.49995 2.98668 3.80911L1.79668 3.92578C1.55168 3.94911 1.33585 3.77411 1.31251 3.52911C1.28918 3.28411 1.46418 3.07411 1.70335 3.05078L2.89335 2.93411C5.99668 2.61911 9.14084 2.74161 12.2908 3.05078C12.53 3.07411 12.705 3.28995 12.6817 3.52911C12.6642 3.75661 12.4717 3.92578 12.25 3.92578Z" fill="#4B5563"></path><path d="M4.95832 3.33675C4.93499 3.33675 4.91165 3.33675 4.88249 3.33091C4.64915 3.29008 4.48582 3.06258 4.52665 2.82925L4.65499 2.06508C4.74832 1.50508 4.87665 0.729248 6.23582 0.729248H7.76415C9.12915 0.729248 9.25749 1.53425 9.34499 2.07091L9.47332 2.82925C9.51415 3.06841 9.35082 3.29591 9.11749 3.33091C8.87832 3.37175 8.65082 3.20841 8.61582 2.97508L8.48749 2.21675C8.40582 1.70925 8.38832 1.61008 7.76998 1.61008H6.24165C5.62332 1.61008 5.61165 1.69175 5.52415 2.21091L5.38999 2.96925C5.35499 3.18508 5.16832 3.33675 4.95832 3.33675Z" fill="#4B5563"></path><path d="M8.87252 13.2708H5.12752C3.09169 13.2708 3.01002 12.1449 2.94586 11.2349L2.56669 5.36075C2.54919 5.12159 2.73586 4.91159 2.97502 4.89409C3.22002 4.88242 3.42419 5.06326 3.44169 5.30242L3.82086 11.1766C3.88502 12.0633 3.90836 12.3958 5.12752 12.3958H8.87252C10.0975 12.3958 10.1209 12.0633 10.1792 11.1766L10.5584 5.30242C10.5759 5.06326 10.7859 4.88242 11.025 4.89409C11.2642 4.91159 11.4509 5.11576 11.4334 5.36075L11.0542 11.2349C10.99 12.1449 10.9084 13.2708 8.87252 13.2708Z" fill="#4B5563"></path><path d="M7.96832 10.0625H6.02582C5.78665 10.0625 5.58832 9.86417 5.58832 9.625C5.58832 9.38583 5.78665 9.1875 6.02582 9.1875H7.96832C8.20748 9.1875 8.40582 9.38583 8.40582 9.625C8.40582 9.86417 8.20748 10.0625 7.96832 10.0625Z" fill="#4B5563"></path><path d="M8.45835 7.72925H5.54169C5.30252 7.72925 5.10419 7.53091 5.10419 7.29175C5.10419 7.05258 5.30252 6.85425 5.54169 6.85425H8.45835C8.69752 6.85425 8.89585 7.05258 8.89585 7.29175C8.89585 7.53091 8.69752 7.72925 8.45835 7.72925Z" fill="#4B5563"></path></svg>
                                       </span>
                                    </button>
                                 </div>
                              </div>
                           )}

                           {agentData?.checkAvailability && (
                              <div className='group-from'>
                                 <span className='end-call-icon'>
                                    <span className='fa fa-calendar'></span>
                                 </span>
                                 <TextField
                                    fullWidth
                                    hiddenLabel
                                    size='small'
                                    variant='standard'
                                    value={agentData.checkAvailability.name}
                                    disabled
                                 />
                                 <div className='edit-remove-btn'>
                                    <button className='edit-btn' onClick={toggleCheckAvailability}>
                                       <span className=''>
                                          <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path d="M4.42391 13.8267C3.99183 13.8267 3.58808 13.6779 3.29766 13.4017C2.92933 13.0546 2.75225 12.5304 2.816 11.9638L3.07808 9.66876C3.12766 9.23668 3.38975 8.66293 3.69433 8.35126L9.50975 2.19585C10.9618 0.658764 12.4777 0.616265 14.0147 2.06835C15.5518 3.52043 15.5943 5.03626 14.1422 6.57335L8.32683 12.7288C8.02933 13.0475 7.47683 13.345 7.04475 13.4158L4.76391 13.8054C4.6435 13.8125 4.53725 13.8267 4.42391 13.8267ZM11.7835 2.06126C11.2381 2.06126 10.7635 2.40126 10.2818 2.91126L4.46641 9.07376C4.32475 9.22252 4.16183 9.57668 4.1335 9.7821L3.87141 12.0771C3.84308 12.3108 3.89975 12.5021 4.02725 12.6225C4.15475 12.7429 4.346 12.7854 4.57975 12.75L6.86058 12.3604C7.066 12.325 7.406 12.1408 7.54766 11.9921L13.3631 5.83668C14.2414 4.90168 14.5602 4.03751 13.2781 2.83335C12.7114 2.28793 12.2227 2.06126 11.7835 2.06126Z" fill="#4B5563" />
                                             <path d="M12.7825 7.75643C12.7684 7.75643 12.7471 7.75643 12.7329 7.75643C10.5229 7.53684 8.74502 5.8581 8.40502 3.66226C8.36252 3.37185 8.56086 3.10268 8.85127 3.05309C9.14169 3.01059 9.41086 3.20893 9.46044 3.49935C9.72961 5.21351 11.1179 6.53101 12.8463 6.70101C13.1367 6.72935 13.3492 6.99143 13.3209 7.28184C13.2854 7.55101 13.0517 7.75643 12.7825 7.75643Z" fill="#4B5563" />
                                             <path d="M15.375 16.1147H2.625C2.33458 16.1147 2.09375 15.8739 2.09375 15.5835C2.09375 15.2931 2.33458 15.0522 2.625 15.0522H15.375C15.6654 15.0522 15.9062 15.2931 15.9062 15.5835C15.9062 15.8739 15.6654 16.1147 15.375 16.1147Z" fill="#4B5563" />
                                          </svg>
                                       </span>
                                    </button>
                                    <button className='edit-btn' onClick={() => {
                                       const updateData = { id: agentData._id, data: { checkAvailability: null } };
                                       dispatch({ type: 'UPDATE_AGENT', payload: updateData });
                                       setAgentData(prev => ({ ...prev, checkAvailability: null }));
                                    }}>
                                      <span className=''>
                                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.25 3.92578C12.2383 3.92578 12.2208 3.92578 12.2033 3.92578C9.11751 3.61661 6.03751 3.49995 2.98668 3.80911L1.79668 3.92578C1.55168 3.94911 1.33585 3.77411 1.31251 3.52911C1.28918 3.28411 1.46418 3.07411 1.70335 3.05078L2.89335 2.93411C5.99668 2.61911 9.14084 2.74161 12.2908 3.05078C12.53 3.07411 12.705 3.28995 12.6817 3.52911C12.6642 3.75661 12.4717 3.92578 12.25 3.92578Z" fill="#4B5563"></path><path d="M4.95832 3.33675C4.93499 3.33675 4.91165 3.33675 4.88249 3.33091C4.64915 3.29008 4.48582 3.06258 4.52665 2.82925L4.65499 2.06508C4.74832 1.50508 4.87665 0.729248 6.23582 0.729248H7.76415C9.12915 0.729248 9.25749 1.53425 9.34499 2.07091L9.47332 2.82925C9.51415 3.06841 9.35082 3.29591 9.11749 3.33091C8.87832 3.37175 8.65082 3.20841 8.61582 2.97508L8.48749 2.21675C8.40582 1.70925 8.38832 1.61008 7.76998 1.61008H6.24165C5.62332 1.61008 5.61165 1.69175 5.52415 2.21091L5.38999 2.96925C5.35499 3.18508 5.16832 3.33675 4.95832 3.33675Z" fill="#4B5563"></path><path d="M8.87252 13.2708H5.12752C3.09169 13.2708 3.01002 12.1449 2.94586 11.2349L2.56669 5.36075C2.54919 5.12159 2.73586 4.91159 2.97502 4.89409C3.22002 4.88242 3.42419 5.06326 3.44169 5.30242L3.82086 11.1766C3.88502 12.0633 3.90836 12.3958 5.12752 12.3958H8.87252C10.0975 12.3958 10.1209 12.0633 10.1792 11.1766L10.5584 5.30242C10.5759 5.06326 10.7859 4.88242 11.025 4.89409C11.2642 4.91159 11.4509 5.11576 11.4334 5.36075L11.0542 11.2349C10.99 12.1449 10.9084 13.2708 8.87252 13.2708Z" fill="#4B5563"></path><path d="M7.96832 10.0625H6.02582C5.78665 10.0625 5.58832 9.86417 5.58832 9.625C5.58832 9.38583 5.78665 9.1875 6.02582 9.1875H7.96832C8.20748 9.1875 8.40582 9.38583 8.40582 9.625C8.40582 9.86417 8.20748 10.0625 7.96832 10.0625Z" fill="#4B5563"></path><path d="M8.45835 7.72925H5.54169C5.30252 7.72925 5.10419 7.53091 5.10419 7.29175C5.10419 7.05258 5.30252 6.85425 5.54169 6.85425H8.45835C8.69752 6.85425 8.89585 7.05258 8.89585 7.29175C8.89585 7.53091 8.69752 7.72925 8.45835 7.72925Z" fill="#4B5563"></path></svg>
                                       </span>
                                    </button>
                                 </div>
                              </div>
                           )}

                           {agentData?.createBooking && (
                              <div className='group-from'>
                                 <span className='end-call-icon'>
                                    <span className='fa fa-calendar'></span>
                                 </span>
                                 <TextField
                                    fullWidth
                                    hiddenLabel
                                    size='small'
                                    variant='standard'
                                    value={agentData.createBooking.name}
                                    disabled
                                 />
                                 <div className='edit-remove-btn'>
                                    <button className='edit-btn' onClick={toggleBookMeeting}>
                                       <span className=''>
                                          <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path d="M4.42391 13.8267C3.99183 13.8267 3.58808 13.6779 3.29766 13.4017C2.92933 13.0546 2.75225 12.5304 2.816 11.9638L3.07808 9.66876C3.12766 9.23668 3.38975 8.66293 3.69433 8.35126L9.50975 2.19585C10.9618 0.658764 12.4777 0.616265 14.0147 2.06835C15.5518 3.52043 15.5943 5.03626 14.1422 6.57335L8.32683 12.7288C8.02933 13.0475 7.47683 13.345 7.04475 13.4158L4.76391 13.8054C4.6435 13.8125 4.53725 13.8267 4.42391 13.8267ZM11.7835 2.06126C11.2381 2.06126 10.7635 2.40126 10.2818 2.91126L4.46641 9.07376C4.32475 9.22252 4.16183 9.57668 4.1335 9.7821L3.87141 12.0771C3.84308 12.3108 3.89975 12.5021 4.02725 12.6225C4.15475 12.7429 4.346 12.7854 4.57975 12.75L6.86058 12.3604C7.066 12.325 7.406 12.1408 7.54766 11.9921L13.3631 5.83668C14.2414 4.90168 14.5602 4.03751 13.2781 2.83335C12.7114 2.28793 12.2227 2.06126 11.7835 2.06126Z" fill="#4B5563" />
                                             <path d="M12.7825 7.75643C12.7684 7.75643 12.7471 7.75643 12.7329 7.75643C10.5229 7.53684 8.74502 5.8581 8.40502 3.66226C8.36252 3.37185 8.56086 3.10268 8.85127 3.05309C9.14169 3.01059 9.41086 3.20893 9.46044 3.49935C9.72961 5.21351 11.1179 6.53101 12.8463 6.70101C13.1367 6.72935 13.3492 6.99143 13.3209 7.28184C13.2854 7.55101 13.0517 7.75643 12.7825 7.75643Z" fill="#4B5563" />
                                             <path d="M15.375 16.1147H2.625C2.33458 16.1147 2.09375 15.8739 2.09375 15.5835C2.09375 15.2931 2.33458 15.0522 2.625 15.0522H15.375C15.6654 15.0522 15.9062 15.2931 15.9062 15.5835C15.9062 15.8739 15.6654 16.1147 15.375 16.1147Z" fill="#4B5563" />
                                          </svg>
                                       </span>
                                    </button>
                                    <button className='edit-btn' onClick={() => {
                                       const updateData = { id: agentData._id, data: { createBooking: null } };
                                       dispatch({ type: 'UPDATE_AGENT', payload: updateData });
                                       setAgentData(prev => ({ ...prev, createBooking: null }));
                                    }}>
                                       <span className=''>
                                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.25 3.92578C12.2383 3.92578 12.2208 3.92578 12.2033 3.92578C9.11751 3.61661 6.03751 3.49995 2.98668 3.80911L1.79668 3.92578C1.55168 3.94911 1.33585 3.77411 1.31251 3.52911C1.28918 3.28411 1.46418 3.07411 1.70335 3.05078L2.89335 2.93411C5.99668 2.61911 9.14084 2.74161 12.2908 3.05078C12.53 3.07411 12.705 3.28995 12.6817 3.52911C12.6642 3.75661 12.4717 3.92578 12.25 3.92578Z" fill="#4B5563"></path><path d="M4.95832 3.33675C4.93499 3.33675 4.91165 3.33675 4.88249 3.33091C4.64915 3.29008 4.48582 3.06258 4.52665 2.82925L4.65499 2.06508C4.74832 1.50508 4.87665 0.729248 6.23582 0.729248H7.76415C9.12915 0.729248 9.25749 1.53425 9.34499 2.07091L9.47332 2.82925C9.51415 3.06841 9.35082 3.29591 9.11749 3.33091C8.87832 3.37175 8.65082 3.20841 8.61582 2.97508L8.48749 2.21675C8.40582 1.70925 8.38832 1.61008 7.76998 1.61008H6.24165C5.62332 1.61008 5.61165 1.69175 5.52415 2.21091L5.38999 2.96925C5.35499 3.18508 5.16832 3.33675 4.95832 3.33675Z" fill="#4B5563"></path><path d="M8.87252 13.2708H5.12752C3.09169 13.2708 3.01002 12.1449 2.94586 11.2349L2.56669 5.36075C2.54919 5.12159 2.73586 4.91159 2.97502 4.89409C3.22002 4.88242 3.42419 5.06326 3.44169 5.30242L3.82086 11.1766C3.88502 12.0633 3.90836 12.3958 5.12752 12.3958H8.87252C10.0975 12.3958 10.1209 12.0633 10.1792 11.1766L10.5584 5.30242C10.5759 5.06326 10.7859 4.88242 11.025 4.89409C11.2642 4.91159 11.4509 5.11576 11.4334 5.36075L11.0542 11.2349C10.99 12.1449 10.9084 13.2708 8.87252 13.2708Z" fill="#4B5563"></path><path d="M7.96832 10.0625H6.02582C5.78665 10.0625 5.58832 9.86417 5.58832 9.625C5.58832 9.38583 5.78665 9.1875 6.02582 9.1875H7.96832C8.20748 9.1875 8.40582 9.38583 8.40582 9.625C8.40582 9.86417 8.20748 10.0625 7.96832 10.0625Z" fill="#4B5563"></path><path d="M8.45835 7.72925H5.54169C5.30252 7.72925 5.10419 7.53091 5.10419 7.29175C5.10419 7.05258 5.30252 6.85425 5.54169 6.85425H8.45835C8.69752 6.85425 8.89585 7.05258 8.89585 7.29175C8.89585 7.53091 8.69752 7.72925 8.45835 7.72925Z" fill="#4B5563"></path></svg>
                                       </span>
                                    </button>
                                 </div>
                              </div>
                           )}

                           {agentData?.customFunctions && Array.isArray(agentData.customFunctions) && agentData.customFunctions.map((customFunction, index) => (
                              <div className='group-from' key={index}>
                                 <span className='end-call-icon'>
                                    <span className='fa fa-sliders-h'></span>
                                 </span>
                                 <TextField
                                    fullWidth
                                    hiddenLabel
                                    size='small'
                                    variant='standard'
                                    value={customFunction.name || `Custom Function ${index + 1}`}
                                    disabled
                                 />
                                 <div className='edit-remove-btn'>
                                    <button className='edit-btn' onClick={() => handleEditCustomFunction(index)}>
                                       <span className=''>
                                          <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path d="M4.42391 13.8267C3.99183 13.8267 3.58808 13.6779 3.29766 13.4017C2.92933 13.0546 2.75225 12.5304 2.816 11.9638L3.07808 9.66876C3.12766 9.23668 3.38975 8.66293 3.69433 8.35126L9.50975 2.19585C10.9618 0.658764 12.4777 0.616265 14.0147 2.06835C15.5518 3.52043 15.5943 5.03626 14.1422 6.57335L8.32683 12.7288C8.02933 13.0475 7.47683 13.345 7.04475 13.4158L4.76391 13.8054C4.6435 13.8125 4.53725 13.8267 4.42391 13.8267ZM11.7835 2.06126C11.2381 2.06126 10.7635 2.40126 10.2818 2.91126L4.46641 9.07376C4.32475 9.22252 4.16183 9.57668 4.1335 9.7821L3.87141 12.0771C3.84308 12.3108 3.89975 12.5021 4.02725 12.6225C4.15475 12.7429 4.346 12.7854 4.57975 12.75L6.86058 12.3604C7.066 12.325 7.406 12.1408 7.54766 11.9921L13.3631 5.83668C14.2414 4.90168 14.5602 4.03751 13.2781 2.83335C12.7114 2.28793 12.2227 2.06126 11.7835 2.06126Z" fill="#4B5563" />
                                             <path d="M12.7825 7.75643C12.7684 7.75643 12.7471 7.75643 12.7329 7.75643C10.5229 7.53684 8.74502 5.8581 8.40502 3.66226C8.36252 3.37185 8.56086 3.10268 8.85127 3.05309C9.14169 3.01059 9.41086 3.20893 9.46044 3.49935C9.72961 5.21351 11.1179 6.53101 12.8463 6.70101C13.1367 6.72935 13.3492 6.99143 13.3209 7.28184C13.2854 7.55101 13.0517 7.75643 12.7825 7.75643Z" fill="#4B5563" />
                                             <path d="M15.375 16.1147H2.625C2.33458 16.1147 2.09375 15.8739 2.09375 15.5835C2.09375 15.2931 2.33458 15.0522 2.625 15.0522H15.375C15.6654 15.0522 15.9062 15.2931 15.9062 15.5835C15.9062 15.8739 15.6654 16.1147 15.375 16.1147Z" fill="#4B5563" />
                                          </svg>
                                       </span>
                                    </button>
                                    <button className='edit-btn' onClick={() => handleDeleteCustomFunction(index)}>
                                      <span className=''>
                                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.25 3.92578C12.2383 3.92578 12.2208 3.92578 12.2033 3.92578C9.11751 3.61661 6.03751 3.49995 2.98668 3.80911L1.79668 3.92578C1.55168 3.94911 1.33585 3.77411 1.31251 3.52911C1.28918 3.28411 1.46418 3.07411 1.70335 3.05078L2.89335 2.93411C5.99668 2.61911 9.14084 2.74161 12.2908 3.05078C12.53 3.07411 12.705 3.28995 12.6817 3.52911C12.6642 3.75661 12.4717 3.92578 12.25 3.92578Z" fill="#4B5563"></path><path d="M4.95832 3.33675C4.93499 3.33675 4.91165 3.33675 4.88249 3.33091C4.64915 3.29008 4.48582 3.06258 4.52665 2.82925L4.65499 2.06508C4.74832 1.50508 4.87665 0.729248 6.23582 0.729248H7.76415C9.12915 0.729248 9.25749 1.53425 9.34499 2.07091L9.47332 2.82925C9.51415 3.06841 9.35082 3.29591 9.11749 3.33091C8.87832 3.37175 8.65082 3.20841 8.61582 2.97508L8.48749 2.21675C8.40582 1.70925 8.38832 1.61008 7.76998 1.61008H6.24165C5.62332 1.61008 5.61165 1.69175 5.52415 2.21091L5.38999 2.96925C5.35499 3.18508 5.16832 3.33675 4.95832 3.33675Z" fill="#4B5563"></path><path d="M8.87252 13.2708H5.12752C3.09169 13.2708 3.01002 12.1449 2.94586 11.2349L2.56669 5.36075C2.54919 5.12159 2.73586 4.91159 2.97502 4.89409C3.22002 4.88242 3.42419 5.06326 3.44169 5.30242L3.82086 11.1766C3.88502 12.0633 3.90836 12.3958 5.12752 12.3958H8.87252C10.0975 12.3958 10.1209 12.0633 10.1792 11.1766L10.5584 5.30242C10.5759 5.06326 10.7859 4.88242 11.025 4.89409C11.2642 4.91159 11.4509 5.11576 11.4334 5.36075L11.0542 11.2349C10.99 12.1449 10.9084 13.2708 8.87252 13.2708Z" fill="#4B5563"></path><path d="M7.96832 10.0625H6.02582C5.78665 10.0625 5.58832 9.86417 5.58832 9.625C5.58832 9.38583 5.78665 9.1875 6.02582 9.1875H7.96832C8.20748 9.1875 8.40582 9.38583 8.40582 9.625C8.40582 9.86417 8.20748 10.0625 7.96832 10.0625Z" fill="#4B5563"></path><path d="M8.45835 7.72925H5.54169C5.30252 7.72925 5.10419 7.53091 5.10419 7.29175C5.10419 7.05258 5.30252 6.85425 5.54169 6.85425H8.45835C8.69752 6.85425 8.89585 7.05258 8.89585 7.29175C8.89585 7.53091 8.69752 7.72925 8.45835 7.72925Z" fill="#4B5563"></path></svg>
                                       </span>
                                    </button>
                                 </div>
                              </div>
                           ))}

                           {/* --------------- transfer call --------------- */}
                           {agentData?.callTransfer && (
                              <div className='group-from'>
                                 <span className='end-call-icon'>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.1792 13.2709C9.52008 13.2709 8.82591 13.1134 8.10841 12.8101C7.40841 12.5126 6.70258 12.1042 6.01425 11.6084C5.33175 11.1067 4.67258 10.5467 4.04841 9.93425C3.43008 9.31008 2.87008 8.65092 2.37425 7.97425C1.87258 7.27425 1.47008 6.57425 1.18425 5.89758C0.880915 5.17425 0.729248 4.47425 0.729248 3.81508C0.729248 3.36008 0.810915 2.92841 0.968415 2.52591C1.13175 2.11175 1.39425 1.72675 1.75008 1.39425C2.19925 0.950915 2.71258 0.729248 3.26091 0.729248C3.48841 0.729248 3.72175 0.781748 3.92008 0.875081C4.14758 0.980081 4.34008 1.13758 4.48008 1.34758L5.83341 3.25508C5.95591 3.42425 6.04925 3.58758 6.11341 3.75091C6.18925 3.92591 6.23008 4.10091 6.23008 4.27008C6.23008 4.49175 6.16591 4.70758 6.04341 4.91175C5.95591 5.06925 5.82175 5.23842 5.65258 5.40758L5.25591 5.82175C5.26175 5.83925 5.26758 5.85091 5.27341 5.86258C5.34341 5.98508 5.48341 6.19508 5.75175 6.51008C6.03758 6.83675 6.30591 7.13425 6.57425 7.40841C6.91841 7.74675 7.20425 8.01508 7.47258 8.23675C7.80508 8.51675 8.02091 8.65675 8.14925 8.72092L8.13758 8.75008L8.56341 8.33008C8.74425 8.14925 8.91925 8.01508 9.08841 7.92758C9.40925 7.72925 9.81758 7.69425 10.2259 7.86341C10.3776 7.92758 10.5409 8.01508 10.7159 8.13758L12.6526 9.51425C12.8684 9.66008 13.0259 9.84675 13.1192 10.0684C13.2067 10.2901 13.2476 10.4942 13.2476 10.6984C13.2476 10.9784 13.1834 11.2584 13.0609 11.5209C12.9384 11.7834 12.7867 12.0109 12.5942 12.2209C12.2617 12.5884 11.9001 12.8509 11.4801 13.0201C11.0776 13.1834 10.6401 13.2709 10.1792 13.2709ZM3.26091 1.60425C2.94008 1.60425 2.64258 1.74425 2.35675 2.02425C2.08841 2.27508 1.90175 2.54925 1.78508 2.84675C1.66258 3.15008 1.60425 3.47091 1.60425 3.81508C1.60425 4.35758 1.73258 4.94675 1.98925 5.55342C2.25175 6.17175 2.61925 6.81342 3.08591 7.45508C3.55258 8.09675 4.08341 8.72092 4.66675 9.31008C5.25008 9.88758 5.88008 10.4242 6.52758 10.8967C7.15758 11.3576 7.80508 11.7309 8.44675 11.9992C9.44425 12.4251 10.3776 12.5242 11.1476 12.2034C11.4451 12.0809 11.7076 11.8942 11.9467 11.6259C12.0809 11.4801 12.1859 11.3226 12.2734 11.1359C12.3434 10.9901 12.3784 10.8384 12.3784 10.6867C12.3784 10.5934 12.3609 10.5001 12.3142 10.3951C12.2967 10.3601 12.2617 10.2959 12.1509 10.2201L10.2142 8.84342C10.0976 8.76175 9.99258 8.70342 9.89341 8.66258C9.76508 8.61008 9.71258 8.55758 9.51425 8.68008C9.39758 8.73842 9.29258 8.82592 9.17591 8.94258L8.73258 9.38008C8.50508 9.60175 8.15508 9.65425 7.88675 9.55508L7.72925 9.48508C7.49008 9.35675 7.21008 9.15841 6.90091 8.89592C6.62091 8.65675 6.31758 8.37675 5.95008 8.01508C5.66425 7.72341 5.37841 7.41425 5.08091 7.07008C4.80675 6.74925 4.60841 6.47508 4.48591 6.24758L4.41591 6.07258C4.38091 5.93842 4.36925 5.86258 4.36925 5.78091C4.36925 5.57091 4.44508 5.38425 4.59091 5.23841L5.02841 4.78341C5.14508 4.66675 5.23258 4.55591 5.29091 4.45675C5.33758 4.38091 5.35508 4.31675 5.35508 4.25841C5.35508 4.21175 5.33758 4.14175 5.30841 4.07175C5.26758 3.97842 5.20341 3.87341 5.12175 3.76258L3.76841 1.84925C3.71008 1.76758 3.64008 1.70925 3.55258 1.66841C3.45925 1.62758 3.36008 1.60425 3.26091 1.60425ZM8.13758 8.75592L8.04425 9.15258L8.20175 8.74425C8.17258 8.73841 8.14925 8.74425 8.13758 8.75592Z" fill="#4B5563"></path></svg>
                                 </span>
                                 <TextField
                                    fullWidth
                                    hiddenLabel
                                    size='small'
                                    variant='standard'
                                    value={agentData.callTransfer.name}
                                    disabled
                                 />
                                 <div className='edit-remove-btn'>
                                    <button className='edit-btn' onClick={toggleCallTransfer}>
                                       <span className=''>
                                          <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path d="M4.42391 13.8267C3.99183 13.8267 3.58808 13.6779 3.29766 13.4017C2.92933 13.0546 2.75225 12.5304 2.816 11.9638L3.07808 9.66876C3.12766 9.23668 3.38975 8.66293 3.69433 8.35126L9.50975 2.19585C10.9618 0.658764 12.4777 0.616265 14.0147 2.06835C15.5518 3.52043 15.5943 5.03626 14.1422 6.57335L8.32683 12.7288C8.02933 13.0475 7.47683 13.345 7.04475 13.4158L4.76391 13.8054C4.6435 13.8125 4.53725 13.8267 4.42391 13.8267ZM11.7835 2.06126C11.2381 2.06126 10.7635 2.40126 10.2818 2.91126L4.46641 9.07376C4.32475 9.22252 4.16183 9.57668 4.1335 9.7821L3.87141 12.0771C3.84308 12.3108 3.89975 12.5021 4.02725 12.6225C4.15475 12.7429 4.346 12.7854 4.57975 12.75L6.86058 12.3604C7.066 12.325 7.406 12.1408 7.54766 11.9921L13.3631 5.83668C14.2414 4.90168 14.5602 4.03751 13.2781 2.83335C12.7114 2.28793 12.2227 2.06126 11.7835 2.06126Z" fill="#4B5563" />
                                             <path d="M12.7825 7.75643C12.7684 7.75643 12.7471 7.75643 12.7329 7.75643C10.5229 7.53684 8.74502 5.8581 8.40502 3.66226C8.36252 3.37185 8.56086 3.10268 8.85127 3.05309C9.14169 3.01059 9.41086 3.20893 9.46044 3.49935C9.72961 5.21351 11.1179 6.53101 12.8463 6.70101C13.1367 6.72935 13.3492 6.99143 13.3209 7.28184C13.2854 7.55101 13.0517 7.75643 12.7825 7.75643Z" fill="#4B5563" />
                                             <path d="M15.375 16.1147H2.625C2.33458 16.1147 2.09375 15.8739 2.09375 15.5835C2.09375 15.2931 2.33458 15.0522 2.625 15.0522H15.375C15.6654 15.0522 15.9062 15.2931 15.9062 15.5835C15.9062 15.8739 15.6654 16.1147 15.375 16.1147Z" fill="#4B5563" />
                                          </svg>
                                       </span>
                                    </button>
                                    <button className='edit-btn' onClick={() => {
                                       const updateData = { id: agentData._id, data: { callTransfer: null } };
                                       dispatch({ type: 'UPDATE_AGENT', payload: updateData });
                                       setAgentData(prev => ({ ...prev, callTransfer: null }));
                                    }}>
                                      <span className=''>
                                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.25 3.92578C12.2383 3.92578 12.2208 3.92578 12.2033 3.92578C9.11751 3.61661 6.03751 3.49995 2.98668 3.80911L1.79668 3.92578C1.55168 3.94911 1.33585 3.77411 1.31251 3.52911C1.28918 3.28411 1.46418 3.07411 1.70335 3.05078L2.89335 2.93411C5.99668 2.61911 9.14084 2.74161 12.2908 3.05078C12.53 3.07411 12.705 3.28995 12.6817 3.52911C12.6642 3.75661 12.4717 3.92578 12.25 3.92578Z" fill="#4B5563"></path><path d="M4.95832 3.33675C4.93499 3.33675 4.91165 3.33675 4.88249 3.33091C4.64915 3.29008 4.48582 3.06258 4.52665 2.82925L4.65499 2.06508C4.74832 1.50508 4.87665 0.729248 6.23582 0.729248H7.76415C9.12915 0.729248 9.25749 1.53425 9.34499 2.07091L9.47332 2.82925C9.51415 3.06841 9.35082 3.29591 9.11749 3.33091C8.87832 3.37175 8.65082 3.20841 8.61582 2.97508L8.48749 2.21675C8.40582 1.70925 8.38832 1.61008 7.76998 1.61008H6.24165C5.62332 1.61008 5.61165 1.69175 5.52415 2.21091L5.38999 2.96925C5.35499 3.18508 5.16832 3.33675 4.95832 3.33675Z" fill="#4B5563"></path><path d="M8.87252 13.2708H5.12752C3.09169 13.2708 3.01002 12.1449 2.94586 11.2349L2.56669 5.36075C2.54919 5.12159 2.73586 4.91159 2.97502 4.89409C3.22002 4.88242 3.42419 5.06326 3.44169 5.30242L3.82086 11.1766C3.88502 12.0633 3.90836 12.3958 5.12752 12.3958H8.87252C10.0975 12.3958 10.1209 12.0633 10.1792 11.1766L10.5584 5.30242C10.5759 5.06326 10.7859 4.88242 11.025 4.89409C11.2642 4.91159 11.4509 5.11576 11.4334 5.36075L11.0542 11.2349C10.99 12.1449 10.9084 13.2708 8.87252 13.2708Z" fill="#4B5563"></path><path d="M7.96832 10.0625H6.02582C5.78665 10.0625 5.58832 9.86417 5.58832 9.625C5.58832 9.38583 5.78665 9.1875 6.02582 9.1875H7.96832C8.20748 9.1875 8.40582 9.38583 8.40582 9.625C8.40582 9.86417 8.20748 10.0625 7.96832 10.0625Z" fill="#4B5563"></path><path d="M8.45835 7.72925H5.54169C5.30252 7.72925 5.10419 7.53091 5.10419 7.29175C5.10419 7.05258 5.30252 6.85425 5.54169 6.85425H8.45835C8.69752 6.85425 8.89585 7.05258 8.89585 7.29175C8.89585 7.53091 8.69752 7.72925 8.45835 7.72925Z" fill="#4B5563"></path></svg>
                                       </span>
                                    </button>
                                 </div>
                              </div>
                           )}

                        </div>

                        {/* <div className='group-from'>
                           <span className='end-call-icon'>
                              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.1792 13.2709C9.52008 13.2709 8.82591 13.1134 8.10841 12.8101C7.40841 12.5126 6.70258 12.1042 6.01425 11.6084C5.33175 11.1067 4.67258 10.5467 4.04841 9.93425C3.43008 9.31008 2.87008 8.65092 2.37425 7.97425C1.87258 7.27425 1.47008 6.57425 1.18425 5.89758C0.880915 5.17425 0.729248 4.47425 0.729248 3.81508C0.729248 3.36008 0.810915 2.92841 0.968415 2.52591C1.13175 2.11175 1.39425 1.72675 1.75008 1.39425C2.19925 0.950915 2.71258 0.729248 3.26091 0.729248C3.48841 0.729248 3.72175 0.781748 3.92008 0.875081C4.14758 0.980081 4.34008 1.13758 4.48008 1.34758L5.83341 3.25508C5.95591 3.42425 6.04925 3.58758 6.11341 3.75091C6.18925 3.92591 6.23008 4.10091 6.23008 4.27008C6.23008 4.49175 6.16591 4.70758 6.04341 4.91175C5.95591 5.06925 5.82175 5.23842 5.65258 5.40758L5.25591 5.82175C5.26175 5.83925 5.26758 5.85091 5.27341 5.86258C5.34341 5.98508 5.48341 6.19508 5.75175 6.51008C6.03758 6.83675 6.30591 7.13425 6.57425 7.40841C6.91841 7.74675 7.20425 8.01508 7.47258 8.23675C7.80508 8.51675 8.02091 8.65675 8.14925 8.72092L8.13758 8.75008L8.56341 8.33008C8.74425 8.14925 8.91925 8.01508 9.08841 7.92758C9.40925 7.72925 9.81758 7.69425 10.2259 7.86341C10.3776 7.92758 10.5409 8.01508 10.7159 8.13758L12.6526 9.51425C12.8684 9.66008 13.0259 9.84675 13.1192 10.0684C13.2067 10.2901 13.2476 10.4942 13.2476 10.6984C13.2476 10.9784 13.1834 11.2584 13.0609 11.5209C12.9384 11.7834 12.7867 12.0109 12.5942 12.2209C12.2617 12.5884 11.9001 12.8509 11.4801 13.0201C11.0776 13.1834 10.6401 13.2709 10.1792 13.2709ZM3.26091 1.60425C2.94008 1.60425 2.64258 1.74425 2.35675 2.02425C2.08841 2.27508 1.90175 2.54925 1.78508 2.84675C1.66258 3.15008 1.60425 3.47091 1.60425 3.81508C1.60425 4.35758 1.73258 4.94675 1.98925 5.55342C2.25175 6.17175 2.61925 6.81342 3.08591 7.45508C3.55258 8.09675 4.08341 8.72092 4.66675 9.31008C5.25008 9.88758 5.88008 10.4242 6.52758 10.8967C7.15758 11.3576 7.80508 11.7309 8.44675 11.9992C9.44425 12.4251 10.3776 12.5242 11.1476 12.2034C11.4451 12.0809 11.7076 11.8942 11.9467 11.6259C12.0809 11.4801 12.1859 11.3226 12.2734 11.1359C12.3434 10.9901 12.3784 10.8384 12.3784 10.6867C12.3784 10.5934 12.3609 10.5001 12.3142 10.3951C12.2967 10.3601 12.2617 10.2959 12.1509 10.2201L10.2142 8.84342C10.0976 8.76175 9.99258 8.70342 9.89341 8.66258C9.76508 8.61008 9.71258 8.55758 9.51425 8.68008C9.39758 8.73842 9.29258 8.82592 9.17591 8.94258L8.73258 9.38008C8.50508 9.60175 8.15508 9.65425 7.88675 9.55508L7.72925 9.48508C7.49008 9.35675 7.21008 9.15841 6.90091 8.89592C6.62091 8.65675 6.31758 8.37675 5.95008 8.01508C5.66425 7.72341 5.37841 7.41425 5.08091 7.07008C4.80675 6.74925 4.60841 6.47508 4.48591 6.24758L4.41591 6.07258C4.38091 5.93842 4.36925 5.86258 4.36925 5.78091C4.36925 5.57091 4.44508 5.38425 4.59091 5.23841L5.02841 4.78341C5.14508 4.66675 5.23258 4.55591 5.29091 4.45675C5.33758 4.38091 5.35508 4.31675 5.35508 4.25841C5.35508 4.21175 5.33758 4.14175 5.30841 4.07175C5.26758 3.97842 5.20341 3.87341 5.12175 3.76258L3.76841 1.84925C3.71008 1.76758 3.64008 1.70925 3.55258 1.66841C3.45925 1.62758 3.36008 1.60425 3.26091 1.60425ZM8.13758 8.75592L8.04425 9.15258L8.20175 8.74425C8.17258 8.73841 8.14925 8.74425 8.13758 8.75592Z" fill="#4B5563"></path></svg>
                           </span>
                           <TextField
                              fullWidth
                              hiddenLabel
                              size='small'
                              name='search'
                              variant='standard'
                              placeholder='end_call'
                              onChange={handleEditChange}
                              value={agentData?.type || ''}
                           />
                           <div className='edit-remove-btn'>
                              <button className='edit-btn'>
                                <span className=''>
                                          <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path d="M4.42391 13.8267C3.99183 13.8267 3.58808 13.6779 3.29766 13.4017C2.92933 13.0546 2.75225 12.5304 2.816 11.9638L3.07808 9.66876C3.12766 9.23668 3.38975 8.66293 3.69433 8.35126L9.50975 2.19585C10.9618 0.658764 12.4777 0.616265 14.0147 2.06835C15.5518 3.52043 15.5943 5.03626 14.1422 6.57335L8.32683 12.7288C8.02933 13.0475 7.47683 13.345 7.04475 13.4158L4.76391 13.8054C4.6435 13.8125 4.53725 13.8267 4.42391 13.8267ZM11.7835 2.06126C11.2381 2.06126 10.7635 2.40126 10.2818 2.91126L4.46641 9.07376C4.32475 9.22252 4.16183 9.57668 4.1335 9.7821L3.87141 12.0771C3.84308 12.3108 3.89975 12.5021 4.02725 12.6225C4.15475 12.7429 4.346 12.7854 4.57975 12.75L6.86058 12.3604C7.066 12.325 7.406 12.1408 7.54766 11.9921L13.3631 5.83668C14.2414 4.90168 14.5602 4.03751 13.2781 2.83335C12.7114 2.28793 12.2227 2.06126 11.7835 2.06126Z" fill="#4B5563" />
                                             <path d="M12.7825 7.75643C12.7684 7.75643 12.7471 7.75643 12.7329 7.75643C10.5229 7.53684 8.74502 5.8581 8.40502 3.66226C8.36252 3.37185 8.56086 3.10268 8.85127 3.05309C9.14169 3.01059 9.41086 3.20893 9.46044 3.49935C9.72961 5.21351 11.1179 6.53101 12.8463 6.70101C13.1367 6.72935 13.3492 6.99143 13.3209 7.28184C13.2854 7.55101 13.0517 7.75643 12.7825 7.75643Z" fill="#4B5563" />
                                             <path d="M15.375 16.1147H2.625C2.33458 16.1147 2.09375 15.8739 2.09375 15.5835C2.09375 15.2931 2.33458 15.0522 2.625 15.0522H15.375C15.6654 15.0522 15.9062 15.2931 15.9062 15.5835C15.9062 15.8739 15.6654 16.1147 15.375 16.1147Z" fill="#4B5563" />
                                          </svg>
                                       </span>
                              </button>
                              <button className='edit-btn'>
                                <span className=''>
                                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.25 3.92578C12.2383 3.92578 12.2208 3.92578 12.2033 3.92578C9.11751 3.61661 6.03751 3.49995 2.98668 3.80911L1.79668 3.92578C1.55168 3.94911 1.33585 3.77411 1.31251 3.52911C1.28918 3.28411 1.46418 3.07411 1.70335 3.05078L2.89335 2.93411C5.99668 2.61911 9.14084 2.74161 12.2908 3.05078C12.53 3.07411 12.705 3.28995 12.6817 3.52911C12.6642 3.75661 12.4717 3.92578 12.25 3.92578Z" fill="#4B5563"></path><path d="M4.95832 3.33675C4.93499 3.33675 4.91165 3.33675 4.88249 3.33091C4.64915 3.29008 4.48582 3.06258 4.52665 2.82925L4.65499 2.06508C4.74832 1.50508 4.87665 0.729248 6.23582 0.729248H7.76415C9.12915 0.729248 9.25749 1.53425 9.34499 2.07091L9.47332 2.82925C9.51415 3.06841 9.35082 3.29591 9.11749 3.33091C8.87832 3.37175 8.65082 3.20841 8.61582 2.97508L8.48749 2.21675C8.40582 1.70925 8.38832 1.61008 7.76998 1.61008H6.24165C5.62332 1.61008 5.61165 1.69175 5.52415 2.21091L5.38999 2.96925C5.35499 3.18508 5.16832 3.33675 4.95832 3.33675Z" fill="#4B5563"></path><path d="M8.87252 13.2708H5.12752C3.09169 13.2708 3.01002 12.1449 2.94586 11.2349L2.56669 5.36075C2.54919 5.12159 2.73586 4.91159 2.97502 4.89409C3.22002 4.88242 3.42419 5.06326 3.44169 5.30242L3.82086 11.1766C3.88502 12.0633 3.90836 12.3958 5.12752 12.3958H8.87252C10.0975 12.3958 10.1209 12.0633 10.1792 11.1766L10.5584 5.30242C10.5759 5.06326 10.7859 4.88242 11.025 4.89409C11.2642 4.91159 11.4509 5.11576 11.4334 5.36075L11.0542 11.2349C10.99 12.1449 10.9084 13.2708 8.87252 13.2708Z" fill="#4B5563"></path><path d="M7.96832 10.0625H6.02582C5.78665 10.0625 5.58832 9.86417 5.58832 9.625C5.58832 9.38583 5.78665 9.1875 6.02582 9.1875H7.96832C8.20748 9.1875 8.40582 9.38583 8.40582 9.625C8.40582 9.86417 8.20748 10.0625 7.96832 10.0625Z" fill="#4B5563"></path><path d="M8.45835 7.72925H5.54169C5.30252 7.72925 5.10419 7.53091 5.10419 7.29175C5.10419 7.05258 5.30252 6.85425 5.54169 6.85425H8.45835C8.69752 6.85425 8.89585 7.05258 8.89585 7.29175C8.89585 7.53091 8.69752 7.72925 8.45835 7.72925Z" fill="#4B5563"></path></svg>
                                       </span>
                              </button>
                           </div>
                        </div> */}
                        <div className='right-btn-area'>
                           <Dropdown className='btn-style-border' isOpen={uiState.dropdownOpen} toggle={() => setUiState(prev => ({ ...prev, dropdownOpen: !prev.dropdownOpen }))} direction='up' style={{ maxHeight: "none", overflowY: "visible" }}>
                              <DropdownToggle caret>
                                 + Add
                              </DropdownToggle>
                              <DropdownMenu>
                                 <DropdownItem onClick={toggleEndCall} index={0}>
                                    <span className='icon fa fa-phone'></span>
                                    End Call
                                 </DropdownItem>
                                 <DropdownItem onClick={toggleCallTransfer} index={0}>
                                    <span className='icon fa fa-phone'></span>
                                    Call Transfer
                                 </DropdownItem>
                                 <DropdownItem onClick={toggleCheckAvailability} index={1}>
                                    <span className='icon fa fa-calendar'></span>
                                    Check Calendar Availability (cal.com)
                                 </DropdownItem>
                                 <DropdownItem onClick={toggleBookMeeting} index={2}>
                                    <span className='icon fa fa-calendar'></span>
                                    Book on the Calendar (cal.com)
                                 </DropdownItem>
                                 <DropdownItem onClick={handcontactdNewCustomFunction} index={2}>
                                    <span className='icon fa fa-sliders-h'></span>
                                    Custom Function
                                 </DropdownItem>
                              </DropdownMenu>
                           </Dropdown>
                        </div>
                     </div>
                  </AccordionDetails>
               </Accordion>

               {/* --------------- Knowledge Base--------------- */}
               <Accordion expanded={uiState.expanded.includes('panel2')} onChange={changeTab('panel2')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel2bh-content' id='panel2bh-header'>
                     <Typography component='span' sx={{ width: '33%', flexShrink: 0 }}>
                        <i className='icon'><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.04163 10.9373C1.80246 10.9373 1.60413 10.739 1.60413 10.4998V4.08317C1.60413 1.51067 2.38579 0.729004 4.95829 0.729004H9.04163C11.6141 0.729004 12.3958 1.51067 12.3958 4.08317V9.9165C12.3958 10.0098 12.3958 10.0973 12.39 10.1907C12.3725 10.4298 12.1566 10.6165 11.9233 10.599C11.6841 10.5815 11.4975 10.3715 11.515 10.1323C11.5208 10.0623 11.5208 9.9865 11.5208 9.9165V4.08317C11.5208 2.00067 11.13 1.604 9.04163 1.604H4.95829C2.86996 1.604 2.47913 2.00067 2.47913 4.08317V10.4998C2.47913 10.739 2.28079 10.9373 2.04163 10.9373Z" fill="var(--primary-color)" /><path d="M9.91663 13.2708H4.08329C2.71829 13.2708 1.60413 12.1567 1.60413 10.7917V10.4125C1.60413 9.25167 2.54913 8.3125 3.70413 8.3125H11.9583C12.1975 8.3125 12.3958 8.51083 12.3958 8.75V10.7917C12.3958 12.1567 11.2816 13.2708 9.91663 13.2708ZM3.70413 9.1875C3.02746 9.1875 2.47913 9.73583 2.47913 10.4125V10.7917C2.47913 11.6783 3.19663 12.3958 4.08329 12.3958H9.91663C10.8033 12.3958 11.5208 11.6783 11.5208 10.7917V9.1875H3.70413Z" fill="var(--primary-color)" /><path d="M9.33329 4.521H4.66663C4.42746 4.521 4.22913 4.32266 4.22913 4.0835C4.22913 3.84433 4.42746 3.646 4.66663 3.646H9.33329C9.57246 3.646 9.77079 3.84433 9.77079 4.0835C9.77079 4.32266 9.57246 4.521 9.33329 4.521Z" fill="var(--primary-color)" /><path d="M7.58329 6.5625H4.66663C4.42746 6.5625 4.22913 6.36417 4.22913 6.125C4.22913 5.88583 4.42746 5.6875 4.66663 5.6875H7.58329C7.82246 5.6875 8.02079 5.88583 8.02079 6.125C8.02079 6.36417 7.82246 6.5625 7.58329 6.5625Z" fill="var(--primary-color)" /><path d="M9.91671 11.375C9.76504 11.375 9.61337 11.3108 9.50254 11.2058C9.39754 11.095 9.33337 10.9433 9.33337 10.7917C9.33337 10.6342 9.39754 10.4883 9.50254 10.3775C9.66587 10.2142 9.92254 10.1617 10.1384 10.255C10.2084 10.2842 10.2725 10.325 10.3309 10.3775C10.4359 10.4883 10.5 10.64 10.5 10.7917C10.5 10.9433 10.4359 11.095 10.3309 11.2058C10.2725 11.2583 10.2142 11.2992 10.1384 11.3283C10.0684 11.3575 9.99254 11.375 9.91671 11.375Z" fill="var(--primary-color)" /></svg></i>
                        Knowledge Base
                     </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                     <div className='detail-accordian-box'>
                        <p>Add knowledge base to provide context to the agent.</p>
                        <div>
                           {/* Add button */}
                           <label className='btn-style-border' htmlFor='file-upload'>+ Add</label>
                           <input
                              type='file'
                              id='file-upload'
                              onChange={handleFileChange}
                              accept='.pdf,.doc,.docx,.txt'
                              style={{ display: 'none', marginBottom: '20px' }}
                           />

                           {/* Uploaded files */}
                           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                              {Array.isArray(agentData?.['knowledgeBase']) && agentData['knowledgeBase'].length > 0 ? (
                                 agentData['knowledgeBase'].map((file, index) => {
                                    const fileName = file['fileUrl']?.split('/').pop() || 'Unknown File';
                                    return (
                                       <div key={index} className='file-item-wrapper'>
                                          <a href={file['fileUrl']} target='_blank' rel='noopener noreferrer' className='file-link'>
                                             <span className='icon fa fa-file'></span> {fileName}
                                          </a>
                                          <button
                                             className='file-delete-btn'
                                             onClick={(e) => {
                                                e.preventDefault();
                                                handleDeleteFile(file['_id'], fileName);
                                             }}
                                             title='Delete file'
                                             aria-label='Delete file'
                                          >
                                             {/* Original cross icon - commented out
                                             <i className='fa fa-times'></i>
                                             */}
                                             {/* Recycle bin icon following Sales AI pattern */}
                                             <i className='fa fa-trash'></i>
                                          </button>
                                       </div>
                                    );
                                 })
                              ) : <p style={{ color: '#888' }}>No files uploaded yet</p>}
                           </div>
                        </div>
                     </div>
                  </AccordionDetails>
               </Accordion>

               {/* --------------- Speech Settings--------------- */}
               <Accordion expanded={uiState.expanded.includes('panel3')} onChange={changeTab('panel3')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel3bh-content' id='panel3bh-header'>
                     <Typography component='span' sx={{ width: '33%', flexShrink: 0 }}>
                        <i className='icon'>
                           <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_4717_9568)">
                                 <path d="M10.7788 7.31201C10.5983 6.96474 10.4195 6.61665 10.2326 6.27299C10.0626 5.96028 9.98337 5.62828 9.97814 5.27417C9.95845 3.998 9.50345 2.89307 8.63043 1.96981C7.77751 1.06745 6.72684 0.565824 5.4776 0.504729C4.80596 0.47177 4.16325 0.614057 3.53743 0.838743C2.51288 1.20612 1.68166 1.81827 1.13623 2.78012C0.762423 3.4389 0.590392 4.15758 0.52367 4.90639C0.440066 5.84412 0.572305 6.74487 1.01042 7.58453C1.49677 8.51623 1.80988 9.49415 1.8758 10.5472C1.9377 11.5372 1.7709 12.4866 1.38825 13.4002C1.36855 13.4468 1.3569 13.4734 1.33559 13.4874L1.95418 13.4891H1.95378C1.96342 13.4525 1.97066 13.4147 1.98352 13.3801C2.67727 11.5163 2.55147 9.68468 1.75964 7.88237C1.55746 7.42215 1.28254 6.99167 1.17964 6.49165C0.884212 5.05913 1.04981 3.71021 1.97548 2.52971C2.52815 1.8243 3.30591 1.46336 4.14918 1.21456C6.72282 0.455291 9.06895 2.3617 9.3901 4.72793C9.43351 5.04707 9.41623 5.37586 9.47531 5.69139C9.52676 5.96591 9.62484 6.23762 9.741 6.49286C9.90218 6.84858 10.0995 7.18781 10.2804 7.53509C10.3483 7.66572 10.3298 7.69748 10.1803 7.69868C9.93554 7.70109 9.69075 7.69707 9.44597 7.70029C9.18793 7.70391 9.08382 7.83615 9.13326 8.09138C9.16582 8.25939 9.19757 8.4278 9.23254 8.59501C9.26831 8.76664 9.22048 8.90049 9.07257 9.00218C8.85472 9.1521 8.64088 9.30685 8.42665 9.4624C8.19312 9.63162 8.21724 9.86233 8.48011 9.98292C8.67022 10.0701 8.86195 10.1541 9.05046 10.2386C8.9351 10.837 8.37641 11.374 7.74737 11.4404C7.31608 11.4858 6.87756 11.4693 6.44226 11.4721C5.84498 11.4765 5.24729 11.4733 4.65 11.4733C4.61102 11.4733 4.57162 11.4721 4.53264 11.4737C4.36061 11.4801 4.24605 11.5867 4.24444 11.7418C4.24243 11.8978 4.35216 12.0119 4.52701 12.0139C4.95789 12.0188 5.38877 12.0159 5.81965 12.0163C5.96556 12.0163 6.11187 12.0163 6.27063 12.0163V13.4991H6.27023L6.83496 13.5003V12.0099C7.09622 12.0099 7.34985 12.0196 7.60267 12.0083C8.54401 11.9653 9.35915 11.2957 9.58826 10.3857C9.66061 10.0979 9.5561 9.87439 9.28761 9.74537C9.22973 9.71764 9.17104 9.69151 9.07418 9.64729C9.67508 9.3374 9.93996 8.9037 9.70482 8.24331C9.90539 8.24331 10.0666 8.24532 10.2277 8.24291C10.7354 8.23407 11.0139 7.7646 10.7788 7.31201Z" fill="var(--primary-color)" stroke="var(--primary-color)" stroke-width="0.2" />
                                 <path d="M13.5016 9.90625C13.4971 10.6784 13.2753 11.3689 12.719 11.9288C12.6844 11.9634 12.6482 11.9968 12.6109 12.0281C12.4686 12.1479 12.3158 12.1467 12.2065 12.0265C12.1 11.9091 12.1121 11.7455 12.2483 11.6246C12.5582 11.3496 12.7624 11.0088 12.8665 10.6125C13.0735 9.82506 12.9859 9.08991 12.4517 8.44198C12.3412 8.30813 12.3452 8.15057 12.4573 8.04727C12.5743 7.93915 12.7391 7.9504 12.8597 8.08425C13.2552 8.52277 13.4465 9.0473 13.5 9.62771C13.5088 9.71975 13.5016 9.8134 13.5016 9.90625Z" fill="var(--primary-color)" stroke="var(--primary-color)" stroke-width="0.2" />
                                 <path d="M12.1227 9.89569C12.1062 10.4271 11.9483 10.9235 11.5515 11.3258C11.4089 11.4709 11.2437 11.4866 11.1255 11.3716C11.0025 11.2522 11.015 11.0979 11.1605 10.9464C11.6617 10.4222 11.7167 9.5649 11.2871 8.97364C11.1681 8.80965 11.1777 8.64445 11.3128 8.54678C11.443 8.45272 11.6002 8.48689 11.72 8.64123C12.0013 9.00379 12.1143 9.4218 12.1227 9.89569Z" fill="var(--primary-color)" stroke="var(--primary-color)" stroke-width="0.2" />
                                 <path d="M1.67225 5.34436C1.69959 4.60881 1.85232 3.90822 2.25547 3.28039C2.76433 2.48776 3.51998 2.05085 4.40626 1.80727C4.9521 1.65735 5.50236 1.61233 6.06025 1.73412C6.27368 1.78074 6.36935 1.90213 6.33196 2.07577C6.2986 2.23052 6.15953 2.30608 5.96137 2.26991C5.01199 2.09587 4.15424 2.34266 3.37528 2.87202C2.7173 3.31938 2.39334 3.98539 2.27919 4.75632C2.23698 5.04049 2.23256 5.33069 2.2189 5.61889C2.20965 5.81584 2.11801 5.93763 1.95562 5.94486C1.79083 5.9521 1.67949 5.82669 1.67306 5.62331C1.66984 5.53046 1.67225 5.43761 1.67225 5.34436Z" fill="var(--primary-color)" stroke="var(--primary-color)" stroke-width="0.2" />
                              </g>
                              <defs>
                                 <clipPath id="clip0_4717_9568">
                                    <rect width="14" height="13" fill="white" />
                                 </clipPath>
                              </defs>
                           </svg>
                        </i>
                        Speech Settings
                     </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                     <div className='detail-accordian-box'>
                        <h4>Background sound</h4>
                        <div className='group-from-sound'>
                           <FormControl fullWidth>
                              <Select
                                 displayEmpty
                                 value={backgroundSoundSettings.soundName}
                                 open={uiState.isBackSound}
                                 onOpen={() => setUiState(prev => ({ ...prev, isBackSound: true }))}
                                 onClose={() => setUiState(prev => ({ ...prev, isBackSound: false }))}
                                 onChange={(e) => handleBackgroundSoundSelect(e.target.value)}
                                 renderValue={(selected) => {
                                    if (!selected) return 'None';
                                    const selectedOption = constants.backgroundSound.find(opt => opt.value === selected);
                                    return selectedOption ? (
                                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <Typography sx={{ fontSize: '14px' }}>
                                             {selectedOption.label}
                                          </Typography>
                                       </Box>
                                    ) : null;
                                 }}
                                 MenuProps={{ disableAutoFocusItem: true }}
                              >
                                 {constants.backgroundSound.map((sound) => (
                                    <MenuItem key={sound.value} value={sound.value}>
                                       {sound.label}
                                    </MenuItem>
                                 ))}
                              </Select>
                           </FormControl>
                           <button 
                              ref={volumeButtonRef}
                              className='setting-btn' 
                              onClick={toggleContentVeriablesBox}
                              type="button"
                              aria-label="Background sound volume settings"
                           >
                             
                              {/* <span className='icon fa fa-gear'></span> */}
                              {/*  Material-UI volume icon */}
                              <VolumeUpIcon style={{ fontSize: '20px', color: 'var(--primary-color)' }} />
                           </button>
                           {showVariablesBox && (
                              <div ref={volumePopupRef} className='slider-group volume-box-popup'>
                                 <h4>Background Sound Volume</h4>
                                 <div className='slider-area'>
                                    <Slider
                                       value={backgroundSoundSettings.volume}
                                       onChange={(e, newValue) => handleBackgroundVolumeChange(e, newValue)}
                                       onChangeCommitted={(e, newValue) => {
                                          const updateData = {
                                             id: agentData._id,
                                             data: {
                                                backgroundSound: {
                                                   soundName: backgroundSoundSettings.soundName,
                                                   volume: newValue
                                                }
                                             }
                                          };
                                          dispatch({ type: 'UPDATE_AGENT', payload: updateData });
                                       }}
                                       aria-labelledby='background-sound-volume-slider'
                                       min={0}
                                       max={100}
                                    />
                                    <input
                                       value={backgroundSoundSettings.volume}
                                       onChange={(e) => {
                                          const newValue = Number(e.target.value);
                                          if (!isNaN(newValue)) {
                                             handleBackgroundVolumeChange(null, Math.min(100, Math.max(0, newValue)));
                                          }
                                       }}
                                       onBlur={() => {
                                          const updateData = {
                                             id: agentData._id,
                                             data: {
                                                backgroundSound: {
                                                   soundName: backgroundSoundSettings.soundName,
                                                   volume: backgroundSoundSettings.volume
                                                }
                                             }
                                          };
                                          dispatch({ type: 'UPDATE_AGENT', payload: updateData });
                                       }}
                                       inputProps={{
                                          min: 0,
                                          max: 100,
                                          type: 'number',
                                          'aria-labelledby': 'background-sound-volume-slider'
                                       }}
                                    />
                                 </div>
                              </div>
                           )}
                        </div>
                        <div className='slider-group'>
                           <h4>Responsiveness</h4>
                           <p>Control how fast the agent responds after users finish speaking.</p>
                           <div className='slider-area'>
                              <Slider
                                 onChange={handleSliderChange}
                                 aria-labelledby='input-slider'
                                 value={typeof valueLLMRange === 'number' ? valueLLMRange : 0}
                              />
                              <input
                                 size='small'
                                 onBlur={handleBlur}
                                 value={valueLLMRange}
                                 onChange={handleInputChange}
                                 inputProps={{ step: 10, min: 0, max: 100, type: 'number', 'aria-labelledby': 'input-slider' }}
                              />
                           </div>
                        </div>
                        <div className='slider-group'>
                           <h4>Enable Backchanneling</h4>
                           <p>Enables the agent to use affirmations like 'yeah' or 'uh-huh' during conversations, indicating active listening and engagement.</p>
                           <div className='switch-box'>
                              <Switch />
                           </div>
                        </div>

                        <div className='slider-group'>
                           <h4>Enable Recording</h4>
                           <p>Enable call recording functionality for this agent.</p>
                           <div className='switch-box'>
                              <Switch
                                 checked={agentData?.enableRecording || false}
                                 onChange={handleRecordingToggle}
                                 color="primary"
                                 inputProps={{ 'aria-label': 'Enable Recording Toggle' }}
                              />
                           </div>
                        </div>

                        <div className='slider-group'>
                           <h4>Enable Transcript</h4>
                           <p>Enable automatic transcript generation for calls made by this agent.</p>
                           <div className='switch-box'>
                              <Switch
                                 checked={agentData?.enableTranscript || false}
                                 onChange={handleTranscriptToggle}
                                 color="primary"
                                 inputProps={{ 'aria-label': 'Enable Transcript Toggle' }}
                              />
                           </div>
                        </div>

                        {/* <div className='slider-group'>
                           <h4>Disable Transcript Formatting</h4>
                           <p>Control how often AI will send a reminder message.</p>
                           <div className='time-box'>
                              <div className='group-from'>
                                 <TextField
                                    fullWidth
                                    name='sec'
                                    hiddenLabel
                                    size='small'
                                    variant='standard'
                                    placeholder='10'
                                 />
                                 <span className='sec-text'>seconds</span>
                              </div>
                              <div className='group-from'>
                                 <TextField
                                    fullWidth
                                    name='time'
                                    hiddenLabel
                                    size='small'
                                    placeholder='1'
                                    variant='standard'
                                 />
                                 <span className='sec-text'>time</span>
                              </div>
                           </div>
                        </div>

                        <div className='slider-group'>
                           <h4>Disable Transcript Formatting</h4>
                           <p>Prevent agent errors like phone numbers being formatted as timestamps.</p>
                        </div>

                        <button className='btn-style-border'>+ Add</button> */}
                     </div>
                  </AccordionDetails>
               </Accordion>

               {/* --------------- End Call--------------- */}
               <Accordion expanded={uiState.expanded.includes('panel4')} onChange={changeTab('panel4')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel4bh-content' id='panel4bh-header'>
                     <Typography component='span' sx={{ width: '33%', flexShrink: 0 }}>
                        <i className='icon'><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.24924 13.2416C1.88424 13.2416 0.729241 12.0866 0.729241 10.7216V7.1283C0.700074 5.42497 1.33007 3.8208 2.50841 2.61913C3.68674 1.4233 5.26757 0.758301 6.97091 0.758301C10.4476 0.758301 13.2709 3.58747 13.2709 7.0583V10.6516C13.2709 12.04 12.1392 13.1716 10.7509 13.1716C9.38591 13.1716 8.23091 12.0166 8.23091 10.6516V9.01247C8.23091 8.16663 8.89591 7.50163 9.74174 7.50163C10.5876 7.50163 11.2526 8.16663 11.2526 9.01247V10.78C11.2526 11.0191 11.0542 11.2175 10.8151 11.2175C10.5759 11.2175 10.3776 11.0191 10.3776 10.78V9.01247C10.3776 8.6158 10.0567 8.37663 9.74174 8.37663C9.34507 8.37663 9.10591 8.69747 9.10591 9.01247V10.6516C9.10591 11.5441 9.85841 12.2966 10.7509 12.2966C11.6434 12.2966 12.3959 11.5441 12.3959 10.6516V7.0583C12.3959 4.0658 9.96341 1.6333 6.97091 1.6333C5.50674 1.6333 4.14757 2.19913 3.13257 3.23163C2.11757 4.26413 1.57507 5.64663 1.60424 7.11663V10.7216C1.60424 11.6141 2.35674 12.3666 3.24924 12.3666C4.14174 12.3666 4.89424 11.6141 4.89424 10.7216V9.08247C4.89424 8.6858 4.57341 8.44663 4.25841 8.44663C3.86174 8.44663 3.62257 8.76747 3.62257 9.08247V10.7858C3.62257 11.025 3.42424 11.2233 3.18507 11.2233C2.94591 11.2233 2.74757 11.025 2.74757 10.7858V9.08247C2.74757 8.23663 3.41257 7.57163 4.25841 7.57163C5.10424 7.57163 5.76924 8.23663 5.76924 9.08247V10.7216C5.76924 12.0866 4.61424 13.2416 3.24924 13.2416Z" fill="var(--primary-color)" /></svg></i>
                        Call Settings
                     </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                     <div className='detail-accordian-box'>
                        <div className='slider-group'>
                           <h4>Voicemail Detection</h4>
                           <p>Hang up or leave a voicemail if a voicemail is detected</p>
                           <div className='switch-box'>
                              <Switch
                                 checked={agentData?.['voiceMailDetection'] || false}
                                 onChange={handleVoiceMailDetectionToggle}
                                 color="primary"
                                 inputProps={{ 'aria-label': 'Enable Voicemail Detection Toggle' }}
                              />
                           </div>
                        </div>

                        <div className='slider-group'>
                           <h4>End Call on Silence</h4>
                           <div className='slider-area'>
                              <Slider
                                 onChange={handleSilenceThresholdChange}
                                 onChangeCommitted={handleSilenceThreshold}
                                 aria-labelledby='silence-threshold-slider'
                                 value={typeof agentData?.silenceThreshold === 'number' ? agentData['silenceThreshold'] : 0}
                                 min={0}
                                 max={100}
                                 step={1}
                              />
                              <input
                                 size='small'
                                 onBlur={handleSilenceBlur}
                                 value={agentData?.silenceThreshold}
                                 onChange={handleSilenceInputChange}
                                 inputProps={{ step: 1, min: 0, max: 100, type: 'number', 'aria-labelledby': 'silence-threshold-slider' }}
                              />
                              <span className='sec-text'>seconds</span>
                           </div>
                        </div>
                        <div className='slider-group'>
                           <h4>Max Call Duration</h4>
                           <div className='slider-area'>
                              <Slider
                                 min={0}
                                 step={1}
                                 max={600}
                                 onChange={handleCallDuration}
                                 aria-labelledby='max-call-duration-slider'
                                 onChangeCommitted={handleCallDChange}
                                 value={typeof agentData?.maxCallDuration === 'number' ? agentData['maxCallDuration'] : 0}
                              />
                              <input
                                 size='small'
                                 onBlur={handleDurationBlur}
                                 value={agentData?.maxCallDuration}
                                 onChange={handleCallDurationInput}
                                 inputProps={{ step: 1, min: 0, max: 600, type: 'number', 'aria-labelledby': 'max-call-duration-slider' }}
                              />
                              <span className='sec-text'> seconds</span>
                           </div>
                        </div>
                        <div className='slider-group'>
                           <h4>Pause Before Speaking</h4>
                           <p>Duration before the assistant starts speaking at the beginning of the call.</p>
                           <div className='slider-area'>
                              <Slider
                                 min={0}
                                 max={5}
                                 step={0.1}
                                 onChangeCommitted={handlePauseChangeCommited}
                                 aria-labelledby='pause-before-speaking-slider'
                                 value={typeof agentData?.pauseBeforeSpeaking === 'number' ? agentData['pauseBeforeSpeaking'] : 0}
                                 onChange={(event, newValue) => setAgentData(prev => ({ ...prev, pauseBeforeSpeaking: newValue }))}
                              />
                              <input
                                 size='small'
                                 onBlur={handlePauseBlur}
                                 value={agentData?.pauseBeforeSpeaking}
                                 onChange={handlePauseInputChange}
                                 inputProps={{
                                    step: 0.1,
                                    min: 0,
                                    max: 5,
                                    type: 'number',
                                    'aria-labelledby': 'pause-before-speaking-slider'
                                 }}
                              />
                              <span className='sec-text'>seconds</span>
                           </div>
                        </div>
                        {/* <button className='btn-style-border'>+ Add</button> */}
                     </div>
                  </AccordionDetails>
               </Accordion>

               {/* --------------- Post-Call Analysis--------------- */}
               <Accordion expanded={uiState.expanded.includes('panel5')} onChange={changeTab('panel5')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel5bh-content' id='panel4bh-header'>
                     <Typography component='span' sx={{ width: '33%', flexShrink: 0 }}>
                        <i className='icon'><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.8333 13.2707H2.91663C1.70913 13.2707 0.729126 12.2907 0.729126 11.0832V1.1665C0.729126 0.927337 0.927459 0.729004 1.16663 0.729004C1.40579 0.729004 1.60413 0.927337 1.60413 1.1665V11.0832C1.60413 11.8065 2.19329 12.3957 2.91663 12.3957H12.8333C13.0725 12.3957 13.2708 12.594 13.2708 12.8332C13.2708 13.0723 13.0725 13.2707 12.8333 13.2707Z" fill="var(--primary-color)" /><path d="M2.91652 10.3542C2.81736 10.3542 2.71236 10.3192 2.63069 10.2492C2.44986 10.0917 2.42652 9.81757 2.58402 9.6309L5.26152 6.50422C5.55319 6.16589 5.97319 5.96173 6.41652 5.94423C6.85986 5.93256 7.29736 6.09589 7.61236 6.41089L8.16652 6.96506C8.31236 7.11089 8.50486 7.18089 8.70902 7.18089C8.91319 7.17506 9.09985 7.08172 9.23402 6.92422L11.9115 3.79756C12.069 3.61673 12.3432 3.59339 12.5299 3.75089C12.7107 3.90839 12.734 4.18255 12.5765 4.36922L9.89902 7.4959C9.60735 7.83423 9.18736 8.03839 8.74402 8.05589C8.30069 8.06756 7.86319 7.90423 7.54819 7.58923L6.99986 7.03506C6.85402 6.88922 6.66152 6.81339 6.45736 6.81923C6.25319 6.82506 6.06652 6.9184 5.93236 7.0759L3.25486 10.2026C3.16152 10.3017 3.03902 10.3542 2.91652 10.3542Z" fill="var(--primary-color)" /></svg></i>
                        Post-Call Analysis
                     </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                     <div className='slider-group'>
                        <h4>Post Call Data Retrieval</h4>
                        <p>Define the information that you need to extract from the call. (Learn more)</p>
                     </div>

                     <div className='detail-accordian-box'>
                        {Array.isArray(agentData?.postCallAnalysis) && agentData.postCallAnalysis.map((item, index) => (
                           <div key={index} className='group-from'>
                              <span className='end-call-icon'>
                                 <span className='fa fa-chart-bar'></span>
                              </span>
                              <TextField
                                 fullWidth
                                 hiddenLabel
                                 size='small'
                                 variant='standard'
                                 value={item.name}
                                 disabled
                              />
                              <div className='edit-remove-btn'>
                                 {/* Edit */}
                                 <button className='edit-btn' onClick={() => { setPostCallAnalysisForm(item); setEditingPostCallAnalysis(index); togglePostCallAnalysis() }}>
                                    <span className=''>
                                       <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M4.42391 13.8267C3.99183 13.8267 3.58808 13.6779 3.29766 13.4017C2.92933 13.0546 2.75225 12.5304 2.816 11.9638L3.07808 9.66876C3.12766 9.23668 3.38975 8.66293 3.69433 8.35126L9.50975 2.19585C10.9618 0.658764 12.4777 0.616265 14.0147 2.06835C15.5518 3.52043 15.5943 5.03626 14.1422 6.57335L8.32683 12.7288C8.02933 13.0475 7.47683 13.345 7.04475 13.4158L4.76391 13.8054C4.6435 13.8125 4.53725 13.8267 4.42391 13.8267ZM11.7835 2.06126C11.2381 2.06126 10.7635 2.40126 10.2818 2.91126L4.46641 9.07376C4.32475 9.22252 4.16183 9.57668 4.1335 9.7821L3.87141 12.0771C3.84308 12.3108 3.89975 12.5021 4.02725 12.6225C4.15475 12.7429 4.346 12.7854 4.57975 12.75L6.86058 12.3604C7.066 12.325 7.406 12.1408 7.54766 11.9921L13.3631 5.83668C14.2414 4.90168 14.5602 4.03751 13.2781 2.83335C12.7114 2.28793 12.2227 2.06126 11.7835 2.06126Z" fill="#4B5563" />
                                          <path d="M12.7825 7.75643C12.7684 7.75643 12.7471 7.75643 12.7329 7.75643C10.5229 7.53684 8.74502 5.8581 8.40502 3.66226C8.36252 3.37185 8.56086 3.10268 8.85127 3.05309C9.14169 3.01059 9.41086 3.20893 9.46044 3.49935C9.72961 5.21351 11.1179 6.53101 12.8463 6.70101C13.1367 6.72935 13.3492 6.99143 13.3209 7.28184C13.2854 7.55101 13.0517 7.75643 12.7825 7.75643Z" fill="#4B5563" />
                                          <path d="M15.375 16.1147H2.625C2.33458 16.1147 2.09375 15.8739 2.09375 15.5835C2.09375 15.2931 2.33458 15.0522 2.625 15.0522H15.375C15.6654 15.0522 15.9062 15.2931 15.9062 15.5835C15.9062 15.8739 15.6654 16.1147 15.375 16.1147Z" fill="#4B5563" />
                                       </svg>
                                    </span>
                                 </button>

                                 {/* Delete */}
                                 <button className='edit-btn' onClick={() => {
                                    const updatedList = agentData.postCallAnalysis.filter((_, i) => i !== index);
                                    const updateData = { id: agentData._id, data: { postCallAnalysis: updatedList } };
                                    dispatch({ type: 'UPDATE_AGENT', payload: updateData });
                                    setAgentData(prev => ({ ...prev, postCallAnalysis: updatedList }));
                                 }}>
                                   <span className=''>
                                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.25 3.92578C12.2383 3.92578 12.2208 3.92578 12.2033 3.92578C9.11751 3.61661 6.03751 3.49995 2.98668 3.80911L1.79668 3.92578C1.55168 3.94911 1.33585 3.77411 1.31251 3.52911C1.28918 3.28411 1.46418 3.07411 1.70335 3.05078L2.89335 2.93411C5.99668 2.61911 9.14084 2.74161 12.2908 3.05078C12.53 3.07411 12.705 3.28995 12.6817 3.52911C12.6642 3.75661 12.4717 3.92578 12.25 3.92578Z" fill="#4B5563"></path><path d="M4.95832 3.33675C4.93499 3.33675 4.91165 3.33675 4.88249 3.33091C4.64915 3.29008 4.48582 3.06258 4.52665 2.82925L4.65499 2.06508C4.74832 1.50508 4.87665 0.729248 6.23582 0.729248H7.76415C9.12915 0.729248 9.25749 1.53425 9.34499 2.07091L9.47332 2.82925C9.51415 3.06841 9.35082 3.29591 9.11749 3.33091C8.87832 3.37175 8.65082 3.20841 8.61582 2.97508L8.48749 2.21675C8.40582 1.70925 8.38832 1.61008 7.76998 1.61008H6.24165C5.62332 1.61008 5.61165 1.69175 5.52415 2.21091L5.38999 2.96925C5.35499 3.18508 5.16832 3.33675 4.95832 3.33675Z" fill="#4B5563"></path><path d="M8.87252 13.2708H5.12752C3.09169 13.2708 3.01002 12.1449 2.94586 11.2349L2.56669 5.36075C2.54919 5.12159 2.73586 4.91159 2.97502 4.89409C3.22002 4.88242 3.42419 5.06326 3.44169 5.30242L3.82086 11.1766C3.88502 12.0633 3.90836 12.3958 5.12752 12.3958H8.87252C10.0975 12.3958 10.1209 12.0633 10.1792 11.1766L10.5584 5.30242C10.5759 5.06326 10.7859 4.88242 11.025 4.89409C11.2642 4.91159 11.4509 5.11576 11.4334 5.36075L11.0542 11.2349C10.99 12.1449 10.9084 13.2708 8.87252 13.2708Z" fill="#4B5563"></path><path d="M7.96832 10.0625H6.02582C5.78665 10.0625 5.58832 9.86417 5.58832 9.625C5.58832 9.38583 5.78665 9.1875 6.02582 9.1875H7.96832C8.20748 9.1875 8.40582 9.38583 8.40582 9.625C8.40582 9.86417 8.20748 10.0625 7.96832 10.0625Z" fill="#4B5563"></path><path d="M8.45835 7.72925H5.54169C5.30252 7.72925 5.10419 7.53091 5.10419 7.29175C5.10419 7.05258 5.30252 6.85425 5.54169 6.85425H8.45835C8.69752 6.85425 8.89585 7.05258 8.89585 7.29175C8.89585 7.53091 8.69752 7.72925 8.45835 7.72925Z" fill="#4B5563"></path></svg>
                                       </span>
                                 </button>
                              </div>
                           </div>
                        ))}

                        <button className='btn-style-border' onClick={() => { setPostCallAnalysisForm({ name: '', description: '' }); setEditingPostCallAnalysis(null); togglePostCallAnalysis(); }}   >
                           + Add
                        </button>
                     </div>
                  </AccordionDetails>
               </Accordion>

               {/* --------------- Security Settings--------------- */}
               {/* <Accordion expanded={uiState.expanded.includes('panel6')} onChange={changeTab('panel6')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel6bh-content' id='panel4bh-header'>
                     <Typography component='span' sx={{ width: '33%', flexShrink: 0 }}>
                        <i className='icon'>
                           <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.99994 13.2765C6.36411 13.2765 5.73411 13.0898 5.23828 12.7223L2.72994 10.8498C2.06494 10.354 1.54578 9.32151 1.54578 8.49318V4.15318C1.54578 3.25484 2.20494 2.29818 3.05078 1.98318L5.96161 0.892344C6.53911 0.67651 7.44911 0.67651 8.02661 0.892344L10.9433 1.98318C11.7891 2.29818 12.4483 3.25484 12.4483 4.15318V8.48734C12.4483 9.31568 11.9291 10.3482 11.2641 10.844L8.75578 12.7165C8.26578 13.0898 7.63578 13.2765 6.99994 13.2765ZM6.27078 1.71484L3.35994 2.80568C2.85828 2.99234 2.42078 3.62234 2.42078 4.15901V8.49318C2.42078 9.04734 2.81161 9.82318 3.24911 10.1498L5.75744 12.0223C6.42828 12.524 7.56578 12.524 8.23661 12.0223L10.7449 10.1498C11.1883 9.81734 11.5733 9.04151 11.5733 8.49318V4.15318C11.5733 3.62234 11.1358 2.99234 10.6341 2.79984L7.72328 1.70901C7.33828 1.56901 6.66161 1.56901 6.27078 1.71484Z" fill="var(--primary-color)" /><path d="M7.00004 7.72933C6.11337 7.72933 5.39587 7.01183 5.39587 6.12516C5.39587 5.2385 6.11337 4.521 7.00004 4.521C7.88671 4.521 8.60421 5.2385 8.60421 6.12516C8.60421 7.01183 7.88671 7.72933 7.00004 7.72933ZM7.00004 5.396C6.59754 5.396 6.27087 5.72266 6.27087 6.12516C6.27087 6.52766 6.59754 6.85433 7.00004 6.85433C7.40254 6.85433 7.72921 6.52766 7.72921 6.12516C7.72921 5.72266 7.40254 5.396 7.00004 5.396Z" fill="var(--primary-color)" /><path d="M7 9.479C6.76083 9.479 6.5625 9.28067 6.5625 9.0415V7.2915C6.5625 7.05234 6.76083 6.854 7 6.854C7.23917 6.854 7.4375 7.05234 7.4375 7.2915V9.0415C7.4375 9.28067 7.23917 9.479 7 9.479Z" fill="var(--primary-color)" /></svg>
                        </i>
                        Security Settings
                     </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                     <div className='detail-accordian-box'>
                        <div className='slider-group'>
                           <h4>Enable Backchanneling</h4>
                           <p>Enables the agent to use affirmations like 'yeah' or 'uh-huh' during conversations, indicating active listening and engagement.</p>
                           <div className='switch-box'>
                              <Switch />
                           </div>
                        </div>
                     </div>
                  </AccordionDetails>
               </Accordion> */}

               {/* --------------- Webhook Settings--------------- */}
               <Accordion expanded={uiState.expanded.includes('panel7')} onChange={changeTab('panel7')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel7bh-content' id='panel4bh-header'>
                     <Typography component='span' sx={{ width: '33%', flexShrink: 0 }}>
                        <i className='icon'><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.00001 7.75817C6.92417 7.75817 6.84834 7.74067 6.77834 7.69984L1.62751 4.719C1.42334 4.5965 1.34751 4.32817 1.47001 4.11817C1.59251 3.90817 1.86084 3.83817 2.07084 3.96067L7.00001 6.81317L11.9 3.97817C12.11 3.85567 12.3783 3.9315 12.5008 4.13567C12.6233 4.34567 12.5475 4.614 12.3433 4.7365L7.22751 7.69984C7.15167 7.73484 7.07584 7.75817 7.00001 7.75817Z" fill="var(--primary-color)" /><path d="M7 13.0433C6.76083 13.0433 6.5625 12.8449 6.5625 12.6058V7.31494C6.5625 7.07577 6.76083 6.87744 7 6.87744C7.23917 6.87744 7.4375 7.07577 7.4375 7.31494V12.6058C7.4375 12.8449 7.23917 13.0433 7 13.0433Z" fill="var(--primary-color)" /><path d="M7.00012 13.2707C6.48679 13.2707 5.97929 13.1598 5.57679 12.9382L2.46179 11.2057C1.61595 10.739 0.956787 9.61317 0.956787 8.64484V5.349C0.956787 4.38067 1.61595 3.26067 2.46179 2.78817L5.57679 1.0615C6.37595 0.618171 7.62429 0.618171 8.42345 1.0615L11.5385 2.794C12.3843 3.26067 13.0435 4.3865 13.0435 5.35484V8.65067C13.0435 9.619 12.3843 10.739 11.5385 11.2115L8.42345 12.9382C8.02095 13.1598 7.51345 13.2707 7.00012 13.2707ZM7.00012 1.604C6.63262 1.604 6.27095 1.67984 6.00262 1.82567L2.88762 3.55817C2.32762 3.86734 1.83179 4.70734 1.83179 5.349V8.64484C1.83179 9.2865 2.32762 10.1265 2.88762 10.4415L6.00262 12.174C6.53345 12.4715 7.46679 12.4715 7.99762 12.174L11.1126 10.4415C11.6726 10.1265 12.1685 9.29234 12.1685 8.64484V5.349C12.1685 4.70734 11.6726 3.86734 11.1126 3.55234L7.99762 1.81984C7.72929 1.67984 7.36762 1.604 7.00012 1.604Z" fill="var(--primary-color)" /></svg></i>
                        Webhook Settings
                     </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                     <div className='detail-accordian-box'>
                        <div className='slider-group'>
                           <h4>Agent Level Webhook URL</h4>
                           <p>Webhook URL (POST) to receive events from Sales AI</p>
                           {/* <p>Webhook URL to receive events from Retell. (Learn more)</p> */}
                           <div className='time-box style-two'>
                              <div className='group-from'>
                                 <TextField
                                    fullWidth
                                    hiddenLabel
                                    size='small'
                                    name='webhookURL'
                                    variant='standard'
                                    placeholder='Add your webhook url here'
                                    value={agentData?.['webhookURL'] || ''}
                                    onChange={handleEditChange}
                                    onBlur={(event) => {
                                       const url = event['target']['value'];
                                       // Updated regex to allow localhost and IP addresses
                                       const urlRegex = new RegExp(/^(?:http(s)?:\/\/)?([\w.-]+|localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::\d+)?(?:\/[\w\-. ~:/?#[\]@!\$&'\(\)\*\+,;=.]*)?$/g);
                                       if (urlRegex.test(url) || url === '') handleUpdateAgent()
                                       else {
                                          EventBus.publish('error', 'Invalid Webhook URL')
                                          setAgentData(prev => ({ ...prev, webhookURL: '' }))
                                       }
                                    }}
                                 />
                              </div>
                           </div>
                        </div>
                     </div>
                  </AccordionDetails>
               </Accordion>

            </div>
         </div>

         {/* --------------- End Call--------------- */}
         <Modal isOpen={uiState.modalEndCall} toggle={toggleEndCall} className={`main-modal new-user-modal modal-dialog-centered endcall-modal`}>
            <ModalHeader toggle={toggleEndCall}></ModalHeader>
            <ModalBody>
               <div className='add-content'>
                  <h2>
                     <span className='icon fa fa-phone'></span>
                     End Call
                  </h2>
                  <div className='group-from'>
                     <label>Name</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='name'
                        variant='standard'
                        placeholder='end_call'
                        value={endCallForm.name}
                        onChange={(e) => handleEndCallFormChange('name', e.target.value)}
                     />
                  </div>
                  <div className='group-from'>
                     <label>Description (Optional)</label>
                     <TextField
                        rows='5'
                        multiline
                        fullWidth
                        hiddenLabel
                        name='description'
                        size='small'
                        variant='standard'
                        placeholder='Description here'
                        value={endCallForm.description}
                        onChange={(e) => handleEndCallFormChange('description', e.target.value)}
                     />
                  </div>

                  <div className='group-from btn-group'>
                     <button className='btn-style-border' onClick={toggleEndCall}>Cancel</button>
                     <button className='btn-style-new' onClick={handleSaveEndCall}>Save</button>
                  </div>
               </div>
            </ModalBody>
         </Modal>

         {/* --------------- Call Transfer--------------- */}
         {/* <Modal isOpen={uiState.modalCallTransfer} toggle={toggleCallTransfer} className='main-modal new-user-modal modal-dialog-centered endcall-modal'>
            <ModalHeader toggle={toggleCallTransfer}></ModalHeader>
            <ModalBody>
               <div className='add-content'>
                  <h2>
                     <span className='icon fa fa-phone'></span>
                     Call Transfer
                  </h2>

                  <div className='group-from'>
                     <label>Name</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        variant='standard'
                        placeholder='Enter transfer name'
                        value={agentData?.callTransfer?.name || ''}
                        onChange={(e) => setAgentData(prev => ({
                           ...prev,
                           callTransfer: {
                              ...prev.callTransfer,
                              name: e.target.value
                           }
                        }))}
                     />
                  </div>

                  <div className='group-from'>
                     <label>Description (Optional)</label>
                     <TextField
                        rows='3'
                        multiline
                        fullWidth
                        hiddenLabel
                        size='small'
                        variant='standard'
                        placeholder='Description here'
                        value={agentData?.callTransfer?.description || ''}
                        onChange={(e) => setAgentData(prev => ({
                           ...prev,
                           callTransfer: {
                              ...prev.callTransfer,
                              description: e.target.value
                           }
                        }))}
                     />
                  </div>
                  <div className='group-from'>
                     <label>Transfer to</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        variant='standard'
                        placeholder='e.g., +14154154155'
                        value={agentData?.callTransfer?.transferTo || ''}
                        onChange={(e) => setAgentData(prev => ({
                           ...prev,
                           callTransfer: {
                              ...prev.callTransfer,
                              transferTo: e.target.value
                           }
                        }))}
                     />
                  </div>

                  <div className='group-from'>
                     <label>Type</label>
                     <div className='radio-group'>
                        <label>
                           <input
                              type='radio'
                              name='transfer_type'
                              value='cold'
                              checked={agentData?.callTransfer?.type === 'cold'}
                              onChange={() => setAgentData(prev => ({
                                 ...prev,
                                 callTransfer: {
                                    ...prev.callTransfer,
                                    type: 'cold'
                                 }
                              }))}
                           /> Cold Transfer
                        </label>
                        <label>
                           <input
                              type='radio'
                              name='transfer_type'
                              value='warm'
                              checked={agentData?.callTransfer?.type === 'warm'}
                              onChange={() => setAgentData(prev => ({
                                 ...prev,
                                 callTransfer: {
                                    ...prev.callTransfer,
                                    type: 'warm'
                                 }
                              }))}
                           /> Warm Transfer
                        </label>
                     </div>
                  </div>

                  <div className='group-from btn-group'>
                     <button className='btn-style-border' onClick={toggleCallTransfer}>Cancel</button>
                     <button
                        className='btn-style-new'
                        onClick={() => {
                           const { name, description, transferTo, type } = agentData.callTransfer || {};
                           // Basic validation
                           if (!name || !transferTo || !type || description) {
                              return;
                           }
                           // Create the payload
                           const payload = {
                              id: agentData._id,
                              data: {
                                 callTransfer: {
                                    name: agentData.callTransfer?.name || '',
                                    description: agentData.callTransfer?.description || '',
                                    transferTo: agentData.callTransfer?.transferTo || '',
                                    type: agentData.callTransfer?.type || 'cold'
                                 }
                              }
                           };

                           // Dispatch the update
                           dispatch({ type: 'UPDATE_AGENT', payload });

                           // Close the modal
                           toggleCallTransfer();
                        }}
                     >
                        Save
                     </button>
                  </div>
               </div>
            </ModalBody>
         </Modal> */}
         <Modal isOpen={uiState.modalCallTransfer} toggle={toggleCallTransfer} className='main-modal new-user-modal modal-dialog-centered endcall-modal'>
            <ModalHeader toggle={toggleCallTransfer}></ModalHeader>
            <ModalBody>
               <div className='add-content'>
                  <h2>
                     <span className='icon fa fa-phone'></span>
                     Call Transfer
                  </h2>

                  <div className='group-from'>
                     <label>Name</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        variant='standard'
                        placeholder='Enter transfer name'
                        value={callTransferForm.name}
                        onChange={(e) => handleCallTransferFormChange('name', e.target.value)}
                     />
                  </div>

                  <div className='group-from'>
                     <label>Description (Optional)</label>
                     <TextField
                        rows='3'
                        multiline
                        fullWidth
                        hiddenLabel
                        size='small'
                        variant='standard'
                        placeholder='Description here'
                        value={callTransferForm.description}
                        onChange={(e) => handleCallTransferFormChange('description', e.target.value)}
                     />
                  </div>

                  <div className='group-from'>
                     <label>Transfer to</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        variant='standard'
                        placeholder='e.g., +14154154155'
                        value={callTransferForm.transferTo}
                        onChange={(e) => handleCallTransferFormChange('transferTo', e.target.value)}
                     />
                  </div>

                  <div className='group-from'>
                     <label>Type</label>
                     <div className='radio-group'>
                        <label>
                           <input
                              type='radio'
                              name='transfer_type'
                              value='cold'
                              checked={callTransferForm.type === 'cold'}
                              onChange={() => handleCallTransferFormChange('type', 'cold')}
                           /> Cold Transfer
                        </label>
                        <label>
                           <input
                              type='radio'
                              name='transfer_type'
                              value='warm'
                              checked={callTransferForm.type === 'warm'}
                              onChange={() => handleCallTransferFormChange('type', 'warm')}
                           /> Warm Transfer
                        </label>
                     </div>
                  </div>

                  <div className='group-from btn-group'>
                     <button className='btn-style-border' onClick={toggleCallTransfer}>Cancel</button>
                     <button
                        className='btn-style-new'
                        onClick={handleSaveCallTransfer}
                     >
                        Save
                     </button>
                  </div>
               </div>
            </ModalBody>
         </Modal>

         {/* Post Call Analysis Modal */}
         <Modal isOpen={uiState.modalPostCallAnalysis} toggle={togglePostCallAnalysis} className='main-modal new-user-modal modal-dialog-centered endcall-modal'>
            <ModalHeader toggle={togglePostCallAnalysis}></ModalHeader>
            <ModalBody>
               <div className='add-content'>
                  <h2>
                     <span className='icon fa fa-chart-bar'></span>
                     Post Call Analysis
                  </h2>
                  <div className='group-from'>
                     <label>Name</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='name'
                        variant='standard'
                        placeholder='detailed_call_summary'
                        value={postCallAnalysisForm.name || ''}
                        onChange={(e) => handlePostCallAnalysisFormChange('name', e.target.value)}
                     />
                  </div>
                  <div className='group-from'>
                     <label>Description</label>
                     <TextField
                        rows='5'
                        multiline
                        fullWidth
                        hiddenLabel
                        name='description'
                        size='small'
                        variant='standard'
                        placeholder='Detailed summary of the call when the call ends analyze the call transcript'
                        value={postCallAnalysisForm.description}
                        onChange={(e) => handlePostCallAnalysisFormChange('description', e.target.value)}
                     />
                  </div>

                  <div className='group-from btn-group'>
                     <button className='btn-style-border' onClick={togglePostCallAnalysis}>Cancel</button>
                     <button className='btn-style-new' onClick={handleSavePostCallAnalysis}>Save</button>
                  </div>
               </div>
            </ModalBody>
         </Modal>

         {/* --------------- Check Availability--------------- */}
         <Modal isOpen={uiState.isAvailability} toggle={toggleCheckAvailability} className={`main-modal new-user-modal modal-dialog-centered endcall-modal`}>
            <ModalHeader toggle={toggleCheckAvailability}></ModalHeader>
            <ModalBody>
               <div className='add-content'>
                  <h2>
                     <span className='icon fa fa-calendar'></span>
                     Check Calendar Availability (cal.com)
                  </h2>
                  <div className='group-from'>
                     <label>Name</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='name'
                        variant='standard'
                        placeholder='check_calendar_availability'
                        value={checkAvailabilityForm.name}
                        onChange={(e) => handleCheckAvailabilityFormChange('name', e.target.value)}
                     />
                  </div>
                  <div className='group-from'>
                     <label>Description (Optional)</label>
                     <TextField
                        rows='5'
                        multiline
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='description'
                        variant='standard'
                        placeholder='Description here'
                        value={checkAvailabilityForm.description}
                        onChange={(e) => handleCheckAvailabilityFormChange('description', e.target.value)}
                     />
                  </div>

                  <div className='group-from'>
                     <label>API Key (Cal.com)</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='apiKey'
                        variant='standard'
                        placeholder='Enter Cal.com API Key'
                        value={checkAvailabilityForm.apiKey}
                        onChange={(e) => handleCheckAvailabilityFormChange('apiKey', e.target.value)}
                     />
                  </div>

                  <div className='group-from'>
                     <label>Event Type ID (Cal.com)</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='eventId'
                        variant='standard'
                        placeholder='Enter Event Type ID'
                        value={checkAvailabilityForm.eventId}
                        onChange={(e) => handleCheckAvailabilityFormChange('eventId', e.target.value)}
                     />
                  </div>

                  <div className='group-from'>
                     <label>Timezone (Optional)</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='timeZone'
                        variant='standard'
                        placeholder='Enter Timezone'
                        value={checkAvailabilityForm.timeZone}
                        onChange={(e) => handleCheckAvailabilityFormChange('timeZone', e.target.value)}
                     />
                  </div>

                  <div className='group-from btn-group'>
                     <button className='btn-style-border' onClick={toggleCheckAvailability}>Cancel</button>
                     <button className='btn-style-new' onClick={handleSaveCheckAvailability}>Save</button>
                  </div>
               </div>
            </ModalBody>
         </Modal>

         {/* --------------- Book Meeting--------------- */}
         <Modal isOpen={uiState.isBookMeeting} toggle={toggleBookMeeting} className={`main-modal new-user-modal modal-dialog-centered endcall-modal`}>
            <ModalHeader toggle={toggleBookMeeting}></ModalHeader>
            <ModalBody>
               <div className='add-content'>
                  <h2>
                     <span className='icon fa fa-calendar'></span>
                     Book on the Calendar (cal.com)
                  </h2>
                  <div className='group-from'>
                     <label>Name</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='name'
                        variant='standard'
                        placeholder='book_calendar'
                        value={createBookingForm.name}
                        onChange={(e) => handleCreateBookingFormChange('name', e.target.value)}
                     />
                  </div>
                  <div className='group-from'>
                     <label>Description (Optional)</label>
                     <TextField
                        rows='5'
                        multiline
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='description'
                        variant='standard'
                        placeholder='Description here'
                        value={createBookingForm.description}
                        onChange={(e) => handleCreateBookingFormChange('description', e.target.value)}
                     />
                  </div>

                  <div className='group-from'>
                     <label>API Key (Cal.com)</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='apiKey'
                        variant='standard'
                        placeholder='Enter Cal.com API Key'
                        value={createBookingForm.apiKey}
                        onChange={(e) => handleCreateBookingFormChange('apiKey', e.target.value)}
                     />
                  </div>

                  <div className='group-from'>
                     <label>Event Type ID (Cal.com)</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='eventId'
                        variant='standard'
                        placeholder='Enter Event Type ID'
                        value={createBookingForm.eventId}
                        onChange={(e) => handleCreateBookingFormChange('eventId', e.target.value)}
                     />
                  </div>

                  <div className='group-from'>
                     <label>Timezone (Optional)</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='timeZone'
                        variant='standard'
                        placeholder='Enter Timezone'
                        value={createBookingForm.timeZone}
                        onChange={(e) => handleCreateBookingFormChange('timeZone', e.target.value)}
                     />
                  </div>

                  <div className='group-from btn-group'>
                     <button className='btn-style-border' onClick={toggleBookMeeting}>Cancel</button>
                     <button className='btn-style-new' onClick={handleSaveCreateBooking}>Save</button>
                  </div>
               </div>
            </ModalBody>
         </Modal>


         {/* --------------- Custom Function--------------- */}
         <Modal isOpen={uiState.isCustomFunction} className={`main-modal new-user-modal modal-dialog-centered endcall-modal`}>
            <ModalHeader toggle={toggleCustomFunction}></ModalHeader>
            <ModalBody>
               <div className='add-content'>
                  <h2>
                     <span className='icon fa fa-sliders-h'></span>
                     {isEditingFunction ? 'Edit Custom Function' : 'Add Custom Function'}
                  </h2>
                  <div className='group-from'>
                     <label>Name</label>
                     <TextField
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='name'
                        variant='standard'
                        placeholder='Enter the name of the custom function'
                        value={customFunctionForm.name}
                        onChange={(e) => handleCustomFunctionFormChange('name', e.target.value)}
                     />
                  </div>
                  <div className='group-from'>
                     <label>Description</label>
                     <TextField
                        rows='5'
                        multiline
                        fullWidth
                        hiddenLabel
                        size='small'
                        name='description'
                        variant='standard'
                        placeholder='Enter the description of the custom function'
                        value={customFunctionForm.description}
                        onChange={(e) => handleCustomFunctionFormChange('description', e.target.value)}
                     />
                  </div>

                  <div className='group-from'>
                     <label>Timeout (ms)</label>
                     <div className='timeout-group'>
                        <TextField
                           fullWidth
                           hiddenLabel
                           size='small'
                           name='timeout'
                           variant='standard'
                           type='number'
                           placeholder='Enter the timeout in milliseconds of the custom function'
                           value={customFunctionForm.timeout}
                           onChange={(e) => handleCustomFunctionFormChange('timeout', e.target.value)}
                        />
                        <span className='milliseconds-text'>milliseconds</span>
                     </div>
                  </div>

                  <div className='group-from'>
                     <label>API Endpoint</label>
                     <span className='api-subtext'>The API Endpoint is the address of the service you are connecting to</span>
                     <div className='row'>
                        <div className='col-md-3'>
                           <FormControl fullWidth>
                              <Select
                                 displayEmpty
                                 value={customFunctionForm.apiEndpointType}
                                 open={uiState['isAPIEndpoint']}
                                 onOpen={() => setUiState(prev => ({ ...prev, isAPIEndpoint: true }))}
                                 onClose={() => setUiState(prev => ({ ...prev, isAPIEndpoint: false }))}
                                 onChange={(e) => handleCustomFunctionFormChange('apiEndpointType', e.target.value)}
                                 renderValue={(selected) => {
                                    if (!selected) return 'Select Type API'; // Show placeholder when nothing is selected

                                    const selectedOption = filteredoptionsApiEndpoint.find(opt => opt.label === selected);

                                    return selectedOption ? (
                                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                          <Typography sx={{ fontSize: '14px' }}>
                                             {selectedOption.label}
                                          </Typography>
                                       </Box>
                                    ) : null;
                                 }}
                                 MenuProps={{ disableAutoFocusItem: true }}
                              >
                                 {/* Show Filtered Options */}
                                 {filteredoptionsApiEndpoint.length > 0 ? filteredoptionsApiEndpoint.map((status) => (
                                    <MenuItem key={status['label']} value={status['label']} onClick={() => handleCustomFunctionFormChange('apiEndpointType', status['label'])}>
                                       {status['label']}
                                    </MenuItem>
                                 )) : <MenuItem disabled>No results found</MenuItem>}
                              </Select>
                           </FormControl>
                        </div>
                        <div className='col-md-9'>
                           <TextField
                              fullWidth
                              hiddenLabel
                              size='small'
                              name='apiEndpoint'
                              variant='standard'
                              placeholder='Enter the URL of the custom function'
                              value={customFunctionForm.apiEndpoint}
                              onChange={(e) => handleCustomFunctionFormChange('apiEndpoint', e.target.value)}
                           />
                        </div>
                     </div>

                  </div>

                  <div className='group-from'>
                     <label>Headers</label>
                     <span className='api-subtext'>Specify the HTTP headers required for your API request.</span>
                     {customFunctionForm.headers && customFunctionForm.headers.length > 0 && customFunctionForm.headers.map((header, index) => (
                        <div className='header-groups' key={index}>
                           <div className='inputs-groups-area'>
                              <TextField
                                 fullWidth
                                 hiddenLabel
                                 size='small'
                                 variant='standard'
                                 placeholder='Key'
                                 value={header.key}
                                 onChange={(e) => {
                                    const newHeaders = [...customFunctionForm.headers];
                                    newHeaders[index].key = e.target.value;
                                    handleCustomFunctionFormChange('headers', newHeaders);
                                 }}
                              />
                           </div>
                           <div className='inputs-groups-area'>
                              <TextField
                                 fullWidth
                                 hiddenLabel
                                 size='small'
                                 variant='standard'
                                 placeholder='Value'
                                 value={header.value}
                                 onChange={(e) => {
                                    const newHeaders = [...customFunctionForm.headers];
                                    newHeaders[index].value = e.target.value;
                                    handleCustomFunctionFormChange('headers', newHeaders);
                                 }}
                              />
                           </div>
                           <div className='btn-area text-right'>
                              <button
                                 className='removed-btn'
                                 onClick={() => {
                                    const newHeaders = customFunctionForm.headers.filter((_, i) => i !== index);
                                    handleCustomFunctionFormChange('headers', newHeaders);
                                 }}
                                 type='button'
                              >
                                 <i className='icon fa fa-trash'></i>
                              </button>
                           </div>
                        </div>
                     ))}
                     <button
                        className='btn-style-border btn-values'
                        onClick={() => {
                           const newHeaders = [...(customFunctionForm.headers || []), { key: '', value: '' }];
                           handleCustomFunctionFormChange('headers', newHeaders);
                        }}
                        type='button'
                     >
                        + New key value pair
                     </button>
                  </div>

                  <div className='group-from'>
                     <label>Query Parameters</label>
                     <span className='api-subtext'>Query string parameteres to append to the URL.</span>
                     {customFunctionForm.queryParameters && customFunctionForm.queryParameters.length > 0 && customFunctionForm.queryParameters.map((param, index) => (
                        <div className='header-groups' key={index}>
                           <div className='inputs-groups-area'>
                              <TextField
                                 fullWidth
                                 hiddenLabel
                                 size='small'
                                 variant='standard'
                                 placeholder='Key'
                                 value={param.key}
                                 onChange={(e) => {
                                    const newParams = [...customFunctionForm.queryParameters];
                                    newParams[index].key = e.target.value;
                                    handleCustomFunctionFormChange('queryParameters', newParams);
                                 }}
                              />
                           </div>
                           <div className='inputs-groups-area'>
                              <TextField
                                 fullWidth
                                 hiddenLabel
                                 size='small'
                                 variant='standard'
                                 placeholder='Value'
                                 value={param.value}
                                 onChange={(e) => {
                                    const newParams = [...customFunctionForm.queryParameters];
                                    newParams[index].value = e.target.value;
                                    handleCustomFunctionFormChange('queryParameters', newParams);
                                 }}
                              />
                           </div>
                           <div className='btn-area text-right'>
                              <button
                                 className='removed-btn'
                                 onClick={() => {
                                    const newParams = customFunctionForm.queryParameters.filter((_, i) => i !== index);
                                    handleCustomFunctionFormChange('queryParameters', newParams);
                                 }}
                                 type='button'
                              >
                                 <i className='icon fa fa-trash'></i>
                              </button>
                           </div>
                        </div>
                     ))}
                     <button
                        className='btn-style-border btn-values'
                        onClick={() => {
                           const newParams = [...(customFunctionForm.queryParameters || []), { key: '', value: '' }];
                           handleCustomFunctionFormChange('queryParameters', newParams);
                        }}
                        type='button'
                     >
                        + New key value pair
                     </button>
                  </div>

                  <div className='group-from'>
                     <label>Parameters (Optional)</label>
                     <span className='api-subtext'>JSON schema that defines the format in which the LLM will return. Please refer to the <Link to="#">docs</Link>.</span>
                     <div className='tabs-box'>
                        <AppBar position='static'>
                           <Tabs value={valueTabUsing} onChange={handleTabsSetCustomVoice} aria-label='simple tabs example'>
                              <Tab label='JSON' />
                              <Tab label='Form' />
                           </Tabs>
                        </AppBar>
                     </div>
                     <div className='tabs-content'>
                        <TabPanel value={valueTabUsing} index={0}>
                           <div className='file-code-area'>
                              <EditorBox
                                 value={valueJsonTemplate}
                                 onChange={(e) => setJsonTemplateValue(e.target.value)}
                                 spellCheck="false"
                              />
                              <div>
                                 <button className='example-btn' variant="outlined" size="small" onClick={() => loadExample(1)}>example 1</button>
                                 <button className='example-btn' variant="outlined" size="small" onClick={() => loadExample(2)}>example 2</button>
                                 <button className='example-btn' variant="outlined" size="small" onClick={() => loadExample(3)}>example 3</button>
                              </div>
                              <button className='jason-btn w100 btn-style-border' onClick={formatJSON}>Format JSON</button>
                           </div>
                        </TabPanel>
                        <TabPanel value={valueTabUsing} index={1}>
                           <div className='from-box-function'>
                              <table>
                                 <thead>
                                    <tr>
                                       <th>Parameter Name</th>
                                       <th>Description</th>
                                       <th>Type</th>
                                       <th>Required</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    {customFunctionParameters.map((param, index) => (
                                       <tr key={index}>
                                          <td>
                                             <div className='inputs-groups-area'>
                                                <TextField
                                                   fullWidth
                                                   hiddenLabel
                                                   size='small'
                                                   variant='standard'
                                                   placeholder='Parameter Name'
                                                   value={param.name}
                                                   onChange={(e) => handleParameterChange(index, 'name', e.target.value)}
                                                />
                                             </div>
                                          </td>
                                          <td>
                                             <div className='inputs-groups-area'>
                                                <TextField
                                                   fullWidth
                                                   hiddenLabel
                                                   size='small'
                                                   variant='standard'
                                                   placeholder='Description'
                                                   value={param.description}
                                                   onChange={(e) => handleParameterChange(index, 'description', e.target.value)}
                                                />
                                             </div>
                                          </td>
                                          <td>
                                             <div className='inputs-groups-area'>
                                                <FormControl fullWidth>
                                                   <Select
                                                      displayEmpty
                                                      value={param.type}
                                                      onChange={(e) => handleParameterChange(index, 'type', e.target.value)}
                                                      renderValue={(selected) => {
                                                         return selected || 'Select Type';
                                                      }}
                                                   >
                                                      <MenuItem value="string">String</MenuItem>
                                                      <MenuItem value="number">Number</MenuItem>
                                                      <MenuItem value="boolean">Boolean</MenuItem>
                                                      <MenuItem value="array">Array</MenuItem>
                                                      <MenuItem value="object">Object</MenuItem>
                                                   </Select>
                                                </FormControl>
                                             </div>
                                          </td>
                                          <td>
                                             <div className='required-box'>
                                                <Checkbox
                                                   checked={param.required}
                                                   onChange={(e) => handleParameterChange(index, 'required', e.target.checked)}
                                                />
                                                <button className='removed-btn' onClick={() => handleRemoveParameter(index)}>
                                                   <i className='fa fa-trash'></i>
                                                </button>
                                             </div>
                                          </td>
                                       </tr>
                                    ))}
                                 </tbody>
                              </table>
                              <button className='btn-style-border btn-values' onClick={handcontactdParameter}>+ Add Parameter</button>
                           </div>
                        </TabPanel>
                     </div>
                  </div>

                  {/* <div className='group-from'>
                     <label>Response Variables</label>
                     <span className='api-subtext'>Extracted values from API response saved as dynamic variables.</span>
                     {showHeadersValues && headersValues.map((headersValues, index) => (
                        <div className='header-groups' key={index}>
                           <div className='inputs-groups-area'>
                              <TextField
                                 fullWidth
                                 hiddenLabel
                                 size='small'
                                 variant='standard'
                                 placeholder='Name of the dynamic variable'
                                 value={headersValues.key}
                                 onChange={(e) => handleHeaderChange(index, 'key', e.target.value)}
                              />
                           </div>
                           <div className='inputs-groups-area'>
                              <TextField
                                 fullWidth
                                 hiddenLabel
                                 size='small'
                                 variant='standard'
                                 placeholder='Path to the value (e.g. properties.enrollment_id.type)'
                                 value={headersValues.value}
                                 onChange={(e) => handleHeaderChange(index, 'value', e.target.value)}
                              />
                           </div>
                           <div className='btn-area text-right'>
                              <button
                                 className='removed-btn'
                                 onClick={() => handleRemoveHeader(index)}
                                 type='button'
                              >
                                 <i className='icon fa fa-trash'></i>
                              </button>
                           </div>
                        </div>
                     ))}
                     {showHeadersValues &&
                        <button className='btn-style-border btn-values' onClick={handcontactdHeader} type='button'>+ New key value pair</button>
                     }
                     {!showHeadersValues &&
                        <button className='btn-style-border btn-values' onClick={toggleHeaderValues} type='button'>+ New key value pair</button>
                     }
                  </div>

                  <div className='group-from check-box-from'>
                     <Checkbox 
                        checked={customFunctionForm.speakDuringExecution}
                        onChange={(e) => handleCustomFunctionFormChange('speakDuringExecution', e.target.checked)}
                     />
                     <div className='text-box'>
                        <h4>Speak During Execution</h4>
                        <p>If the function takes over 2 seconds, the agent can say something like: "Let me check that for you."</p>
                     </div>
                  </div>

                  <div className='group-from check-box-from'>
                     <Checkbox 
                        checked={customFunctionForm.speakAfterExecution}
                        onChange={(e) => handleCustomFunctionFormChange('speakAfterExecution', e.target.checked)}
                     />
                     <div className='text-box'>
                        <h4>Speak After Execution</h4>
                        <p>Unselect if you want to run the function silently, such as uploading the call result to the server silently.</p>
                     </div>
                  </div> */}

                  <div className='group-from btn-group'>
                     <button className='btn-style-border' onClick={toggleCustomFunction}>Cancel</button>
                     <button className='btn-style-new' onClick={handleSaveCustomFunction}>
                        {isEditingFunction ? 'Update' : 'Save'}
                     </button>
                  </div>
               </div>
            </ModalBody>
         </Modal>

      </>
   );
}


function TabPanel(props) {
   const { children, value, index, ...other } = props;
   return (
      <div role='tabpanel' hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other} >
         {value === index && (<Box p={3}> <Typography>{children}</Typography> </Box>)}
      </div>
   );
}

TabPanel.propTypes = { children: PropTypes.node, index: PropTypes.any['isRequired'], value: PropTypes.any['isRequired'] };

const EditorBox = styled('textarea')({
   width: '100%',
   height: '300px',
   backgroundColor: '#1e1e1e',
   color: '#fff',
   border: 'none',
   padding: '16px',
   fontFamily: 'monospace',
   fontSize: '14px',
   borderRadius: '8px',
   resize: 'vertical',
});

const jsonTemplate = `{
  "type": "object",
  "properties": {
    "appointment_available_ts": {
      "type": "string",
      "description": "The timestamp of the appointment that is available for booking."
    },
    "doctor_name": {
      "type": "string",
      "description": "An optional field to specify the name of the doctor."
    }
  }
}`;


export default Functions

